import type { TranslationModule } from '../types';

export const documentEditorTranslations: TranslationModule = {
  ro: {
    legalPrompt: {
      formattedSuccess: "Actul a fost generat și formatat. Poți restaura documentul anterior prin Anulare.",
      attachmentsTitle: "Înscrisuri pentru analiză",
      attachFiles: "Atașează înscrisuri",
      attachmentsHelp: "Opțional: maximum 10 fișiere, 10 MB fiecare. PDF (maximum 200 pagini), DOCX, TXT sau imagini; OCR pentru maximum 20 pagini scanate/fișier. Textul extras va fi inclus integral în prompt, în limita contextului disponibil. Fișierele sunt procesate temporar, fără salvare. Verifică datele preluate prin OCR în actul generat.",
      removeAttachment: "Elimină {name}",
      extractingAttachment: "Extragere text: {name}",
      attachmentSelectionError: "Alege cel mult 10 fișiere ne-goale, de maximum 10 MB fiecare, în formatele acceptate.",
      attachmentReadError: "Nu am putut extrage integral textul din „{name}”. Verifică fișierul sau elimină-l și reîncearcă. Nu s-a trimis promptul către AI.",
      attachmentLimitError: "„{name}” depășește limita de extracție: 10 MB, 200 pagini PDF, 20 pagini OCR sau 2 milioane de caractere. Împarte înscrisul în mai multe fișiere și reîncearcă.",
      attachmentOcrError: "Textul scanat din „{name}” nu poate fi recunoscut momentan. Reîncearcă sau folosește un PDF cu text selectabil.",
      generateDocumentBtn: 'Generează actul direct în editor',
      writingDocument: 'Redactăm și tehnoredactăm actul. Poate dura câteva minute; documentul actual rămâne intact.',
      replaceTitle: 'Înlocuiești conținutul documentului?',
      replaceWarning: 'După generarea completă, conținutul actual din spațiul de editare va fi șters și înlocuit cu actul cerut. Descarcă documentul actual înainte dacă vrei să păstrezi o copie.',
      replaceSafety: 'Înlocuirea se face numai dacă generarea reușește și documentul nu a fost modificat între timp. Poți reveni la documentul anterior folosind butonul Anulare din mesajul de confirmare.',
      reviewGenerated: 'Datele sunt pseudonimizate înainte de procesarea AI. Numele, adresele și celelalte date sunt restaurate automat în act. Verifică redactarea și completează informațiile lipsă înainte de utilizare.',
      confirmReplace: 'Confirmă și generează actul',
      cancelReplace: 'Înapoi',
      cancelGeneration: 'Oprește generarea',
      editorUnavailable: 'Editorul nu este pregătit pentru înlocuirea documentului.',
      generationFailed: 'Actul nu a putut fi generat integral. Documentul actual nu a fost modificat. Poți încerca din nou.',
      generationQuota: 'Limita de generare a fost atinsă sau există deja o generare în curs. Documentul nu a fost modificat.',
      promptTooLarge: 'Promptul depășește limita dedicată generării. Redu contextul și încearcă din nou; documentul nu a fost modificat.',
      title: 'Generează prompt pentru LLM',
      button: 'Generează prompt pentru LLM',
      buttonShort: 'Generează prompt',
      subtitle: 'Vom adăuga automat tot contextul juridic produs de Analiza AI',
      userRequestLabel: 'Ce vrei să obții?',
      userRequestPlaceholder: 'Ex.: Creează o întâmpinare și răspunde punctual susținerilor părții adverse.',
      autoAddedContext: 'Context adăugat automat:',
      ctxDoc: 'document integral anonimizat',
      ctxFacts: 'situația de fapt și fapte extrase',
      ctxAnalysis: 'analiza AI și verificări de risc',
      ctxArticles: 'acte normative și citări validate',
      ctxCase: 'cea mai relevantă speță',
      ctxDoctrine: 'doctrină și taxă de timbru',
      ctxAnnexes: 'anexe: articole incidente, doctrină, spețe integrale',
      generateBtn: 'Generează prompt',
      generating: 'Pregătim contextul promptului…',
      stepVersion: 'Verificăm versiunea documentului',
      stepPseudonymize: 'Anonimizăm documentul în siguranță',
      stepCase: 'Încărcăm speța relevantă și doctrina',
      stepBuild: 'Construim promptul Markdown',
      readyTitle: 'Prompt pregătit',
      charactersCount: '{count} caractere',
      largePromptWarning: 'Promptul este mare. Verifică limita de context a modelului în care îl vei utiliza.',
      copyBtn: 'Copiază prompt',
      downloadBtn: 'Descarcă .md',
      modifyBtn: 'Modifică solicitarea',
      closeBtn: 'Închide',
      copiedToast: 'Prompt copiat în clipboard.',
      copyError: 'Promptul nu a putut fi copiat.',
      staleError: 'Documentul a fost modificat după ultima analiză. Rulează din nou Analiză AI pentru a genera un prompt actualizat.',
      staleHint: 'Documentul conține modificări recente ce nu au fost încă analizate de AI.',
      reanalyzeBtn: 'Reanalizează documentul',
      pseudonymizeError: 'Documentul nu a putut fi anonimizat în siguranță. Promptul nu a fost generat.',
      noCaseNotice: 'Analiza curentă nu a identificat o speță suficient de relevantă pentru includere.',
    },
    promptGenerator: {
      title: 'Generează prompt pentru LLM',
      button: 'Generează prompt pentru LLM',
      buttonShort: 'Generează prompt',
      subtitle: 'Vom adăuga automat tot contextul juridic produs de Analiza AI',
      userRequestLabel: 'Ce vrei să obții?',
      userRequestPlaceholder: 'Ex.: Creează o întâmpinare și răspunde punctual susținerilor părții adverse.',
      autoAddedContext: 'Context adăugat automat:',
      ctxDoc: 'document integral anonimizat',
      ctxFacts: 'situația de fapt și fapte extrase',
      ctxAnalysis: 'analiza AI și verificări de risc',
      ctxArticles: 'acte normative și citări validate',
      ctxCase: 'cea mai relevantă speță',
      ctxDoctrine: 'doctrină și taxă de timbru',
      ctxAnnexes: 'anexe: articole incidente, doctrină, spețe integrale',
      generateBtn: 'Generează prompt',
      generating: 'Pregătim contextul promptului…',
      stepVersion: 'Verificăm versiunea documentului',
      stepPseudonymize: 'Anonimizăm documentul în siguranță',
      stepCase: 'Încărcăm speța relevantă și doctrina',
      stepBuild: 'Construim promptul Markdown',
      readyTitle: 'Prompt pregătit',
      charactersCount: '{count} caractere',
      largePromptWarning: 'Promptul este mare. Verifică limita de context a modelului în care îl vei utiliza.',
      copyBtn: 'Copiază prompt',
      downloadBtn: 'Descarcă .md',
      modifyBtn: 'Modifică solicitarea',
      closeBtn: 'Închide',
      copiedToast: 'Prompt copiat în clipboard.',
      copyError: 'Promptul nu a putut fi copiat.',
      staleError: 'Documentul a fost modificat după ultima analiză. Rulează din nou Analiză AI pentru a genera un prompt actualizat.',
      staleHint: 'Documentul conține modificări recente ce nu au fost încă analizate de AI.',
      reanalyzeBtn: 'Reanalizează documentul',
      pseudonymizeError: 'Documentul nu a putut fi anonimizat în siguranță. Promptul nu a fost generat.',
      noCaseNotice: 'Analiza curentă nu a identificat o speță suficient de relevantă pentru includere.',
    },
    calculators: {
      menuLabel: 'Calculatoare',
      taxaTimbru: 'Taxă judiciară de timbru',
      termeneJudiciare: 'Termene judiciare',
      contopiri: 'Contopiri pedepse',
      pensieAlimentara: 'Pensie alimentară',
      termeneLegale: 'Termene legale',
      limite: 'Limite pedeapsă',
      prescriptie: 'Prescripție penală',
      reabilitare: 'Reabilitare',
      salariu: 'Salariu Net / Brut',
    },
    schemesModal: {
      modalTitle: 'Inserare Schemă Juridică',
      modalSubtitle: 'Diagrame, clasificări și fluxuri logice decizionale pentru documentul tău',
      searchPlaceholder: 'Caută scheme (ex: nulitate, prescripție, executare silită, recurs)…',
      allSubjects: 'Toate materiile',
      allTopics: 'Toate temele',
      filterByTopic: 'Filtrează după temă',
      noSchemesFound: 'Nicio schemă găsită',
      noSchemesFoundDesc: 'Încearcă alți termeni de căutare sau alege o altă materie/temă.',
      selectSchemePrompt: 'Selectează o schemă din listă',
      selectSchemePromptDesc: 'Alege o schemă juridică din stânga pentru a previzualiza structura și a o insera în document.',
      insertBtn: 'Inserează în document',
      inserting: 'Se generează diagrama…',
      demoBadge: 'Gratuit / Demo',
      proBadge: 'Pro',
      lockedTitle: 'Conținut inclus în abonamentul Pro',
      lockedDesc: 'Poți include gratuit schemele demonstrative din fiecare temă. Activează un abonament Pro pentru acces complet la toate cele 598 de scheme juridice.',
      lockedAction: 'Vezi abonamentele Pro',
      legalBasis: 'Temei legal',
      backToList: 'Înapoi la listă',
      previewTitle: 'Previzualizare schemă',
      successToast: 'Schema juridică a fost inserată cu succes în document.',
      errorToast: 'Nu am putut insera schema în document. Te rugăm să reîncerci.',
      close: 'Închide',
    },
    insert: {
      legalSchemes: 'Schemă juridică…',
    },
    intelligence: {
      "doctrineTab": "Doctrină",
      "stampDutyTab": "Taxă de timbru",
      "argumentSource": "Sursa",
      "argumentHint": "Pasaje din spețele găsite. Alege pasajul potrivit și inserează-l în document împreună cu sursa.",
      "argumentActionError": "Operațiunea nu a reușit. Încearcă din nou.",
      "resultSections": "Secțiunile rezultatului",
      "argumentsLoadError": "Pasajele de doctrină și taxă de timbru nu au putut fi încărcate.",
      "argumentsRetry": "Reîncearcă",
      "casesTab": "Spețe",
      "summary": "Rezumat",
      "analysisTab": "Analiză",
      "generate": "Analizează AI",
      "reanalyze": "Reanalizează AI",
      "analyzing": "Se analizează documentul…",
      "ready": "Rezultat disponibil",
      "privacy": "Textul este anonimizat înainte de trimiterea către AI. Rezultatul rămâne doar în memoria sesiunii.",
      "document_too_short": "Analiza AI necesită minimum {words} cuvinte și {characters} caractere fără spații.",
      "document_too_long_for_single_pass": "Documentul depășește limita pentru o singură analiză completă.",
      "unavailable": "Analiza AI nu este disponibilă. Sunt afișate doar observațiile locale. Nu s-a trimis o cerere de completare.",
      "empty": "Apasă „Analizează AI” pentru a identifica spețe relevante, rezumatul și analiza juridică.",
      "minContentHint": "Adaugă minimum 6 cuvinte (cel puțin 50 de caractere) în document pentru a activa Analiza AI.",
      "authPromptTitle": "Autentificare necesară",
      "authPromptSubtitle": "Pentru analiza avansată AI a documentului",
      "authPromptMessage": "Analiza AI este disponibilă utilizatorilor înregistrați. Creează un cont gratuit sau autentifică-te pentru a analiza documentul.",
      "createFreeAccount": "Creează cont gratuit",
      "loginRequired": "Autentificare",
      "shortContextTitle": "Context prea scurt pentru Rezumat și Analiză completă",
      "shortContextDesc": "Documentul conține un context scurt sau conceptual, motiv pentru care AI-ul a optat pentru căutarea și filtrarea spețelor relevante după cuvinte-cheie juridice (disponibile în secțiunea „Spețe”). Adaugă situația de fapt detaliată în document și apasă „Reanalizează AI” pentru a genera rezumatul și analiza juridică.",
      "viewFilteredCasesBtn": "Vezi spețele relevante identificate",
      "stageTitle": "Analiză AI în curs de procesare",
      "stageSubtitle": "Rezultatele pentru Spețe, Rezumat și Analiză vor fi afișate simultan imediat ce procesarea este completă.",
      "stage1Title": "Evaluarea documentului și căutarea spețelor candidate",
      "stage1Desc": "Analizăm textul pseudonimizat și selectăm motorul optim (cuvinte-cheie juridice sau situație de fapt).",
      "stage2Title": "Generarea rezumatului și a analizei juridice",
      "stage2Desc": "Extragem structura juridică, părțile, cronologia, citările și verificările de risc.",
      "stage2Skipped": "Omisă automat (context scurt — căutare după cuvinte-cheie)",
      "stage3Title": "Filtrarea semantică AI și ordonarea spețelor după relevanță",
      "stage3Desc": "Excludem spețele nerelevante și ordonăm hotărârile descrescător după scorul de relevanță AI.",
      "executive": "Rezumat executiv",
      "parties": "Părți și roluri",
      "subject_matter": "Obiect",
      "contract_terms": "Termeni esențiali",
      "obligations": "Obligații",
      "claims_or_accusations": "Pretenții / acuzații",
      "defenses": "Apărări",
      "evidence": "Probe",
      "procedural_history": "Cronologie procedurală",
      "decisions_and_outcomes": "Soluții și stadiu",
      "penalties_and_deductions": "Pedepse, contopiri și deduceri",
      "open_questions": "Informații lipsă sau neclare",
      "facts": "Date extrase",
      "statistics": "Statistici locale: {words} cuvinte · {paragraphs} paragrafe",
      "analysis": "Analiză juridică AI",
      "local": "Observații deterministe locale",
      "risk": "Risc global",
      "low": "Scăzut",
      "medium": "Mediu",
      "high": "Ridicat",
      "unknown": "Necunoscut",
      "recommendation": "Recomandare",
      "sections": {
            "qualification": "Încadrare juridică",
            "substantive": "Analiză de fond",
            "procedure": "Procedură",
            "evidence": "Probleme probatorii",
            "risk": "Contraargumente și riscuri",
            "calculation": "Calcule",
            "other": "Concluzii și alte verificări"
      },
      "severity": {
            "risk": "Risc",
            "warning": "Atenție",
            "info": "Informare"
      },
      "citedText": "Text citat din document (apasă pentru navigare)",
},
    page: {
      title: 'Editor DOCX Online pentru Documente Juridice | LegeaAplicată',
      description:
        'Editează documente DOCX online în LegeaAplicată, pe desktop sau mobil, cu formatare, citări legislative, anonimizare, modele, rezumare și comparare de versiuni.',
    },
    auth: {
      title: 'Autentificare necesară',
      description:
        'Pentru a utiliza Editorul de Documente Word, este necesar să fii înregistrat și conectat în contul tău LegeaAplicată.',
      guaranteesTitle: 'Garanții de confidențialitate:',
      guarantee1: 'Editare DOCX 100% self-hosted, direct în browser',
      guarantee2: 'Arhitectură zero-persistență: documentele nu sunt salvate pe disk',
      guarantee3: 'Anonimizare automată și verificare citări juridice în memorie',
      guarantee4: 'Documentul dispare automat la închiderea sau reîncărcarea paginii',
      login: 'Autentifică-te în cont',
      register: 'Creează cont gratuit',
      backToPlatform: 'Înapoi la platformă',
    },
    start: {
      back: 'Înapoi',
      backTitle: 'Revino la pagina anterioară',
      title: 'Editor DOCX online pentru documente juridice',
      subtitle:
        'Documentele sunt procesate într-o sesiune privată și nu sunt păstrate după închiderea sau reîncărcarea paginii.',
      privacyBadge: 'Sesiune privată — zero persistență',
      privacyExplanation:
        'Documentul tău există exclusiv în memoria volatilă (RAM) pe durata vizitei curente. Reîncărcarea paginii (F5) sau închiderea ferestrei șterge documentul irevocabil. Descarcă fișierul DOCX înainte de a părăsi editorul pentru a-ți păstra modificările.',
      uploadButton: 'Încarcă DOCX, PDF sau imagine',
      uploadHint1:
        'DOCX se deschide direct. Pentru PDF și imagini extragem textul și îl transformăm într-un document editabil.',
      uploadHint2:
        'PDF și imagini: max. 10 MB · PDF/TIFF: max. 3 pagini/cadre',
      newDocument: 'Document nou',
      compareVersions: 'Compară versiuni',
      cancel: 'M-am răzgândit, înapoi la platformă',
      noWordInstalled: 'Fără Word instalat',
      zeroPersistence: 'Zero persistență',
      autoCleanup: 'Auto-curățare la ieșire',
      cancelLoading: 'Anulează',
    },
    topBar: {
      exit: 'Ieșire',
      exitTitle: 'Închide documentul și revino la ecranul de start',
      exitAria: 'Revenire',
      branding: 'Editor DOCX',
      privateSession: 'Sesiune privată',
      privateSessionInfo: 'Informații sesiune privată',
      zeroPersistenceTitle: 'Zero persistență — Memorie volatilă',
      zeroPersistenceDesc:
        'Documentul există numai cât timp această pagină este deschisă. Reîncărcarea sau închiderea paginii încheie sesiunea definitiv. Descarcă fișierul DOCX pentru a păstra modificările.',
      renameTitle: 'Apasă pentru a redenumi fișierul DOCX',
      undownloadedChanges: 'Modificări nedescărcate',
      undownloadedConversion: 'Conversie nedescărcată',
      downloaded: 'Descărcat',
      headerFooter: 'Antet și subsol',
      headerFooterTooltip: 'Personalizează antetul, subsolul și numerotarea paginilor',
      compareVersions: 'Compară versiuni',
      compareVersionsTooltip: 'Compară două versiuni ale unui contract sau document',
      compareDocuments: 'Compară documente',
      downloadDocx: 'Descarcă DOCX',
      downloadDocxTooltip: 'Descarcă documentul DOCX (Ctrl+S) - Singura metodă de păstrare',
      helpGuide: 'Ghid LegeaAplicată',
      hideAssistant: 'Ascunde panoul asistent',
      showAssistant: 'Afișează panoul asistent',
    },
    unsaved: {
      replaceTitle: 'Documentul curent nu este salvat',
      exitTitle: 'Documentul nu este salvat',
      replaceSubtitle: 'Ai modificări care vor fi pierdute dacă deschizi alt document.',
      exitSubtitle: 'Ai modificări care există exclusiv în sesiunea curentă.',
      replaceWarning:
        'LegeaAplicată nu păstrează documentele editorului. Dacă deschizi un alt document fără a-l descărca pe cel actual, documentul curent și modificările nedescărcate vor fi pierdute definitiv.',
      exitWarning:
        'LegeaAplicată nu păstrează documentele editorului. Dacă părăsești această pagină, documentul și modificările nedescărcate vor fi pierdute definitiv.',
      downloadAndContinue: 'Descarcă documentul actual și continuă',
      stayInEditor: 'Rămâi în editor',
      continueWithoutDownload: 'Continuă fără descărcare',
      leaveWithoutDownload: 'Părăsește fără descărcare',
    },
    loading: {
      preparingWorkspace: 'Se pregătește spațiul de lucru în memorie...',
      loadingRedline: 'Se încarcă documentul cu modificări în editor...',
      cancel: 'Anulează',
    },
    errors: {
      downloadError: 'Eroare la descărcarea documentului.',
      loadError: 'Eroare la încărcarea documentului.',
      transferExpired: 'Transferul documentului a expirat. Încarcă din nou documentul.',
      unsupportedFile: 'Format de fișier neacceptat.',
      conversionError: 'Eroare la conversia fișierului.',
      conversionTimeout:
        'Conversia a durat prea mult. Încearcă un document mai mic sau cu text selectabil.',
      createError: 'Eroare la crearea documentului.',
      anonymizationScanError: 'Eroare la scanarea datelor personale.',
      analysisError: 'Eroare la analiza documentului.',
      openRedlineError: 'Nu s-a putut deschide redline-ul în editor.',
      downloadRedlineError: 'Eroare la descărcarea documentului cu modificări.',
      close: 'Închide',
      staleAnalysis:
        'Documentul a fost modificat după ultima analiză. Reanalizați pentru date actualizate.',
      staleAnalysisHint: 'Documentul conține modificări recente ce nu au fost încă analizate de AI.',
      reanalyzeNow: 'Reanalizează acum',
      fileTooLarge: 'Fișierul depășește limita admisă de {maxSize}.',
      emptyFile: 'Fișierul selectat este gol.',
    },
    assistant: {
      openPanel: 'Deschide panoul LegeaAplicată',
      closePanel: 'Închide panoul',
      title: 'Asistent',
      rail: {
        models: 'Modele',
        modelsFull: 'Modele juridice',
        similarCases: 'Spețe',
        similarCasesFull: 'Spețe similare',
        dictionary: 'Dicționar',
        dictionaryFull: 'Dicționar juridic',
        citations: 'Citări',
        citationsFull: 'Citări legislative',
        anonymization: 'Anonimizare',
        anonymizationFull: 'Anonimizare document',
        companies: 'PF/PJ',
        companiesFull: 'PF/PJ (Persoane Fizice / Juridice)',
        pdfTools: 'PDF',
        pdfToolsFull: 'Instrumente PDF',
        analysis: 'Analiză AI',
        analysisFull: 'Analiză AI (Spețe, Rezumat și Analiză)',
        guide: 'Ghid LegeaAplicată',
        ariaLabel: 'Instrumente juridice asistent',
        switchTo: 'Comută la {name}',
      },
      citations: {
        title: 'Citări',
        highlight: 'Evidențiază citări',
        foundSubtitle: 'Am găsit citări pe baza conținutului din document:',
        legalActsCount: 'Acte juridice ({count})',
        empty: 'Nu au fost detectate citări legislative în document.',
        clearResults: 'Șterge rezultate',
        options: 'Opțiuni citare',
        openHere: 'Deschide aici',
        openInPlatform: 'Deschide în LegeaAplicată',
        openFull: 'Deschide complet',
        back: 'Înapoi',
        versionFrom: 'Versiune de la: {date}',
        officialVerified:
          'Verificat în baza oficială LegeaAplicată conform ultimelor actualizări din Monitorul Oficial.',
        status: {
          found: 'în vigoare',
          repealed: 'abrogat',
          review: 'de verificat',
          unresolved: 'neidentificat',
          service_error: 'arhivă',
        },
      },
      models: {
        title: 'Modele juridice',
        count: '{count} modele',
        subtitle: 'Caută și inserează direct în document.',
        searchPlaceholder: 'Caută un model juridic...',
        clearSearch: 'Șterge căutarea',
        categories: {
          all: 'Toate',
          civil: 'Civil',
          penal: 'Penal',
          labor: 'Muncă',
        },
        error: 'Eroare la încărcarea modelelor juridice.',
        retry: 'Reîncearcă',
        searching: 'Se caută modele...',
        emptyTitle: 'Nu am găsit niciun model pentru căutarea ta.',
        emptyHint:
          'Încearcă să folosești termeni mai generali precum „contract”, „cerere”, „notificare” sau selectează altă categorie.',
        preview: 'Previzualizează',
        insert: 'Inserează',
        inserting: 'Inserez...',
        loadMore: 'Încarcă mai multe modele',
        loadingMore: 'Se încarcă mai multe...',
        backToResults: 'Înapoi la rezultate',
        loadingText: 'Se încarcă textul modelului...',
        noPreviewContent: 'Nu există conținut disponibil pentru previzualizare.',
        insertInDoc: 'Inserează în document',
        insertedToast: 'Model inserat în document.',
        insertErrorToast: 'Eroare la inserarea modelului în document.',
        defaultTitle: 'Model Act Juridic',
        generalModel: 'Model juridic general',
      },
      similarCases: {
        title: 'Spețe similare',
        count: '{count} hotărâri',
        subtitle: 'Găsește hotărâri cu situații de fapt apropiate de documentul curent.',
        privacyPill: 'Conținutul este pseudonimizat înainte de analiza AI.',
        searchButton: 'Caută spețe similare',
        updateButton: 'Actualizează rezultatele',
        preparingFacts: 'Pregătim situația de fapt...',
        searchingJurisprudence: 'Căutăm în jurisprudență...',
        formattingResults: 'Pregătim rezultatele...',
        preparingFactsDesc: 'Analizăm textul pseudonimizat pentru similaritate factuală.',
        searchingJurisprudenceDesc:
          'Comparăm faptele cu baza națională de hotărâri judecătorești.',
        formattingResultsDesc: 'Structurăm extrasele și legăturile sigure.',
        factualSemanticMode: 'Căutare după situația de fapt',
        keywordsMode: 'Căutare după termeni relevanți',
        usedCriteria: 'Criterii folosite',
        caseObjectHeader: 'Obiectul cauzei identificat:',
        factualSummaryHeader:
          'Rezumatul situației de fapt folosit pentru identificarea spețelor:',
        noFactualSummary: 'Nu există rezumat factual specificat.',
        keywordGroupsHeader: 'Grupuri de cuvinte-cheie juridice (Solr):',
        keywordsHeader: 'Termeni juridici folosiți la căutare:',
        rerankingInProgress: 'Filtrăm spețele după rezumatul documentului...',
        rerankingInProgressDesc:
          'Comparăm rezumatul documentului cu situația de fapt a fiecărei spețe candidate.',
        rerankedBadge: 'Filtrate semantic cu Rezumat & Analiză',
        rerankedCount: '{kept} relevante din {total} candidate',
        rawCandidatesHint:
          'Rezultate candidate inițiale. Rulează „Rezumat & Analiză” pentru filtrare semantică automată.',
        rerankedEmptyTitle:
          'Nicio speță candidată nu a întrunit pragul de relevanță semantică.',
        rerankedEmptyDesc:
          'Am evaluat {total} spețe candidate față de rezumatul documentului, însă situațiile lor de fapt privesc alte contexte juridice. Poți încărca mai multe candidate sau afișa candidatele brute.',
        rerankFailedError:
          'Filtrarea semantică AI a spețelor candidate nu a putut fi finalizată. Încearcă din nou.',
        showRawCandidates: 'Afișează candidatele brute ({count})',
        showFilteredCandidates: 'Afișează doar spețele relevante ({count})',
        rerankReasons: {
          same_legal_object_and_facts: 'Obiect și situație de fapt similare',
          similar_factual_pattern: 'Tipar factual comparabil',
          same_remedy_and_context: 'Același remediu și context juridic',
          different_legal_institution: 'Altă instituție juridică',
          different_factual_context: 'Alt context factual',
          insufficient_case_facts: 'Date factuale insuficiente',
        },
        staleWarning: 'Documentul a fost modificat după această căutare.',
        updateNow: 'Actualizează',
        retry: 'Reîncearcă',
        insufficientContentTitle:
          'Documentul nu conține încă suficiente informații pentru identificarea unor spețe relevante.',
        insufficientContentDesc:
          'Adaugă situația de fapt sau elementele juridice esențiale în document și încearcă din nou.',
        smartSearchTitle: 'Căutare inteligentă de spețe',
        smartSearchDesc:
          'Apasă pe butonul de mai sus pentru a analiza conținutul documentului tău și a găsi hotărâri judecătorești cu situații de fapt similare.',
        emptyTitle: 'Nu am găsit spețe relevante pentru conținutul actual al documentului.',
        emptyDesc:
          'Poți completa situația de fapt sau reformula documentul și relua căutarea.',
        resumeSearch: 'Reia căutarea',
        loadMore: 'Încarcă mai multe spețe',
        loadingMore: 'Se încarcă mai multe...',
        veryHigh: 'Relevanță foarte ridicată',
        high: 'Relevanță ridicată',
        medium: 'Relevanță medie',
        orientative: 'Relevanță orientativă',
        keywordMatch: 'Potrivire după termeni',
        censoredNotice: 'Conținut parțial protejat conform Deciziei CSM 998/2022',
        viewDetails: 'Vezi detalii',
        courtFallback: 'Instanță',
        upsellTitle: 'Deblochează toate spețele relevante',
        upsellMessage: 'Au fost identificate {relevantCount} spețe relevante. Sunt afișate primele {displayedCount} conform abonamentului Basic. Treci la PRO pentru a vedea până la 50 de spețe relevante pentru fiecare document.',
        upsellCta: 'Activează Pro',
        allRelevantShown: 'Sunt afișate toate cele {count} spețe relevante identificate.',
        proRerankSummary: 'Sunt afișate {displayed} spețe relevante ordonate după relevanță AI (analizate din {candidates} candidați).',
        caseFallback: 'Hotărâre judecătorească',
        backToCases: 'Înapoi la spețe',
        csmNoticeTitle: 'Conținut protejat prin Decizia CSM 998/2022',
        csmNoticeDesc:
          'Datele de identificare au fost cenzurate conform normelor Consiliului Superior al Magistraturii. Secțiunile indisponibile nu pot fi copiate sau inserate.',
        loadingDetails: 'Se încarcă detaliile speței...',
        noFullText: 'Textul complet al acestei hotărâri nu este disponibil pentru afișare.',
        copied: 'Text copiat în clipboard.',
        copyError: 'Eroare la copierea textului.',
        inserted: 'Secțiune inserată în document.',
        insertError: 'Eroare la inserarea în document.',
        insertHeader: 'Speță similară — {court}',
        insertDate: 'Data: {date}',
        insertObject: 'Obiect: {obj}',
        copy: 'Copiază',
        copiedBtn: 'Copiat',
        expandAll: 'Extinde toate',
        collapseAll: 'Restrânge toate',
        downloadPdf: 'Descarcă PDF',
        print: 'Printează',
        share: 'Distribuie',
        pdfDownloaded: 'PDF-ul a fost descărcat.',
        pdfError: 'Eroare la descărcarea PDF.',
        printError: 'Eroare la inițierea printării.',
        sections: {
          facts: 'Situația de fapt',
          courtArguments: 'Argumentele instanței',
          considerations: 'Considerente',
          decision: 'Hotărârea / Soluția',
          aiSummary: 'Rezumat AI',
          takeaway: 'Ce învățăm din această speță',
          legalBasis: 'Temei legal incident',
          evidence: 'Probe reținute',
        },
      },
      dictionary: {
        title: 'Dicționar juridic',
        subtitle: 'Caută definiții juridice fără să părăsești documentul.',
        searchPlaceholder: 'Caută un termen juridic...',
        clearSearch: 'Șterge căutarea',
        singleResult: '1 rezultat',
        multipleResults: '{count} rezultate',
        searching: 'Se caută în Dicționarul juridic...',
        errorTitle: 'Dicționarul juridic nu este disponibil momentan.',
        errorDesc: 'Verifică conexiunea la internet sau reîncearcă operațiunea.',
        retry: 'Reîncearcă',
        initialTitle: 'Dicționarul juridic LegeaAplicată',
        initialHint:
          'Tastează un termen mai sus sau selectează un cuvânt din document și apasă',
        emptyTitle: 'Nu am găsit acest termen în Dicționarul juridic.',
        emptyHint: 'Încearcă o formulare mai scurtă sau un termen juridic echivalent.',
        backToResults: 'Înapoi la rezultate',
        openInNewTab: 'Deschide în Dicționar',
        openInNewTabTooltip: 'Deschide în Dicționarul juridic într-o filă nouă',
        loadingDefinition: 'Se încarcă definiția juridică...',
        loadError: 'Eroare la încărcare',
        shortDefinition: 'Definiție pe scurt',
        extendedDefinition: 'Definiție extinsă',
        synonyms: 'Sinonime',
        searchSynonym: 'Caută „{syn}”',
        associatedTerms: 'Termeni asociați',
        legalBasisArticles: 'Temei legal / Articole',
        associatedJurisprudence: 'Jurisprudență asociată',
        practicalExamples: 'Exemple practice',
        similarTerms: 'Termeni similari',
        copyDefinition: 'Copiază definiția',
        copied: 'Copiat!',
      },
      anonymization: {
        title: 'Anonimizare Document',
        engine: 'Motor LegeaAplicată',
        scanButton: 'Scanează date personale',
        scanning: 'Se scanează datele personale...',
        appliedSuccess: 'S-au anonimizat cu succes {count} câmpuri în document.',
        identifiedCounts: 'Identificate: {total} ({selected} selectate)',
        selectAll: 'Selectează tot',
        deselectAll: 'Deselectează',
        allCategories: 'Toate',
        emptyHint:
          'Apasă pe butonul de mai sus pentru a identifica automat Persoane, CNP, IBAN, CI, adrese și alte date confidențiale.',
        viewInDoc: 'Vezi în document',
        applyButton: 'Aplică anonimizarea ({count})',
        applying: 'Se aplică anonimizarea în document...',
        categories: {
          ALL: 'Toate',
          PERSON: 'Persoane',
          CNP: 'CNP',
          IBAN: 'IBAN',
          CI: 'Serie CI',
          ADDRESS: 'Adrese',
          PHONE: 'Telefon',
          EMAIL: 'Email',
          COMPANY: 'Societăți',
          DATE: 'Date',
        },
      },
      companies: {
        title: 'PF/PJ (Persoane Fizice / Juridice)',
        entityCount: '{count} entitate',
        entityCountPlural: '{count} entități',
        subtitleAuto: 'Entități identificate automat în document.',
        subtitleOnDemand: 'Verificările în ECRIS și ONRC se efectuează numai la cerere.',
        onrc: {
          check: "Firme / rol ONRC",
          tooltip: "Verifică dacă persoana figurează ca administrator, director, reprezentant sau în altă calitate în societăți comerciale.",
          checking: "Se verifică registrele ONRC…",
          title: "Roluri în firme (ONRC)",
          singleResult: "1 rezultat",
          results: "{count} rezultate",
          empty: "Nu au fost identificate asocieri cu societăți comerciale pentru această persoană.",
          partial: "Rezultate disponibile; lista poate fi incompletă. Căutarea după nume poate include omonime.",
          emptyPartial: "Nu au fost găsite asocieri în rezultatele disponibile. Exhaustivitatea nu este confirmată.",
          unknownRole: "Calitate neconfirmată pentru numele căutat",
          error: "Nu s-a putut efectua verificarea ONRC.",
          rateLimit: "Limita de căutări a fost atinsă. Așteaptă înainte de a reîncerca.",
          unavailable: "Serviciul de verificare este temporar indisponibil. Încearcă din nou.",
          retry: "Reîncearcă",
          viewAll: "Vezi toate cele {count} rezultate încărcate",
          collapse: "Restrânge rezultatele",
          openFull: "Deschide căutarea completă",
          cui: "CUI",
          registry: "Nr. Reg. Com.",
        },
        refreshTitle: 'Actualizează entitățile',
        refreshAria: 'Actualizează societățile și persoanele',
        filterAll: 'Toate {count}',
        filterCompanies: 'Societăți {count}',
        filterPersons: 'Persoane {count}',
        identifying: 'Se identifică entitățile...',
        identifyingDesc: 'Scanăm documentul pentru societăți și persoane fizice.',
        empty: 'Nicio societate sau persoană identificată în document.',
        emptyDesc: 'Entitățile sunt detectate automat la deschiderea acestui panou.',
        scanAgain: 'Scanează din nou',
        emptyCompanies: 'Nicio societate identificată în document.',
        emptyPersons: 'Nicio persoană fizică identificată în document.',
        switchToAll: 'Comută la filtrul „Toate”',
        personFallback: 'Persoană fizică',
        occurrenceCount: '{count} apariție',
        occurrenceCountPlural: '{count} apariții',
        quoteNav: 'Navighează la acest pasaj în document',
        checkCourtCases: 'Verifică procese în instanță',
        verifiedInDb: 'Verificată în bază',
        textMention: 'Mențiune text',
        balance: 'Bilanț {year}',
        employees: '{count} angajați',
        turnover: 'Cifră de afaceri',
        netProfit: 'Profit net',
        companyDetails: 'Detalii societate',
        litigation: {
          checking: 'Se verifică...',
          empty: 'Nu au fost găsite procese în baza internă.',
          error: 'Nu s-a putut verifica acum. Încearcă din nou.',
          retry: 'Reîncearcă',
          title: 'Procese în instanță',
          singleCase: '1 dosar identificat',
          multipleCases: '{count} dosare identificate',
          caseClickTooltip: 'Click pentru detalii complete dosar',
          pendingStatus: 'Pe rol',
          unspecifiedCourt: 'Instanță nespecificată',
          collapse: 'Restrânge lista dosarelor',
          viewAll: 'Vezi toate dosarele ({count})',
        },
      },
      analysis: {
        title: 'Analiză Juridică',
        deterministicRules: 'Reguli deterministe',
        analyzeButton: 'Analizează documentul',
        analyzing: 'Se analizează documentul...',
        words: 'Cuvinte',
        paragraphs: 'Paragrafe',
        findings: 'Constatări',
        reading: 'Lectură',
        readingMinutes: '{count} min',
        filterAll: 'Toate ({count})',
        filterChecks: 'Verificări ({count})',
        filterFacts: 'Date & Sume ({count})',
        emptyInitial:
          'Apasă pe butonul de analiză pentru a extrage automat cronologia, penalitățile, termenele și clauzele cheie din document.',
        emptyCategory: 'Nu au fost identificate elemente în această categorie.',
        viewInDoc: 'Vezi în document',
        kinds: {
          penalty: 'Penalități',
          termination: 'Încetare',
          placeholder: 'De completat',
          jurisdiction: 'Competență',
          date: 'Dată',
          amount: 'Sumă',
          case: 'Dosar',
        },
      },
    },
    comparison: {
      title: 'Compară versiuni contract',
      subtitle:
        'Analiză deterministă OOXML și semantică juridică între două versiuni de document.',
      initialVersion: 'Versiunea inițială (A)',
      revisedVersion: 'Versiunea revizuită (B)',
      swapVersions: 'Schimbă versiunile între ele',
      useActiveDoc: 'Folosește documentul deschis',
      activeDocSelected: 'Documentul curent din editor',
      selectDocx: 'Apasă pentru a alege fișierul DOCX',
      dropDocx: 'Trage fișierul DOCX aici sau apasă pentru a naviga',
      fileReady: 'Fișier pregătit pentru comparare',
      perspectiveTitle: 'Perspectiva de analiză juridică (opțional)',
      perspectiveHint:
        'Alege partea pe care o reprezinți pentru a evalua dacă modificările îți sunt favorabile sau defavorabile.',
      perspectiveNeutral: 'Perspectivă neutră (egală pentru ambele părți)',
      partyClient: 'Client / Cumpărător / Beneficiar / Locatar',
      partyProvider: 'Prestator / Furnizor / Vânzător / Locator',
      partyEmployer: 'Angajator',
      partyEmployee: 'Angajat',
      partyCustom: 'Altă parte (specifică denumirea)...',
      customPartyPlaceholder: 'Ex: SC Alpha Logistics SRL sau Nume Prenume',
      securityGuaranteeTitle: 'Garanții de securitate și confidențialitate:',
      security1:
        'Memorie volatilă exclusivă (RAM) — fișierele nu se stochează pe disc',
      security2:
        'Algoritmul determinist calculează modificările OOXML reale la nivel de paragraf și clauză',
      security3:
        'Analiza AI detectează riscuri ascunse, obligații nou-introduse și termene schimbate',
      security4:
        'Documentul cu Track Changes generat se poate deschide direct în Word sau în editor',
      cancel: 'Anulează',
      startComparison: 'Compară versiunile',
      comparing: 'Se compară versiunile...',
      stage1: 'Se pregătesc documentele în memorie...',
      stage2: 'Se analizează diferențele de text și structură...',
      stage3: 'Se evaluează impactul juridic cu AI...',
      stage4: 'Se generează documentul cu modificări (redline)...',
      resultsTitle: 'Rezultatele comparării documentelor',
      openInEditor: 'Deschide în editor',
      downloadRedline: 'Descarcă DOCX cu modificări',
      newComparison: 'Comparare nouă',
      tabLegal: 'Ce s-a schimbat juridic',
      tabAllChanges: 'Toate modificările documentului',
      priorityHigh: 'Prioritate ridicată',
      priorityMedium: 'Prioritate medie',
      priorityLow: 'Prioritate redusă',
      materialChange: 'Modificare materială',
      wordingOnly: 'Doar reformulare',
      beforeQuote: 'Anterior (Versiunea A)',
      afterQuote: 'Revizuit (Versiunea B)',
      explanation: 'Explicație juridică',
      recommendation: 'Recomandare',
      viewInDocument: 'Vezi în document',
      noFindings:
        'Nu au fost identificate modificări juridice semnificative între cele două versiuni.',
      noChanges: 'Nu există diferențe structurale detectate.',
      genericError: 'A apărut o eroare la compararea documentelor.',
      nativeRedlineBadge: 'Redline generat cu Word Tracked Changes native',
      summary: {
        addedClauses: 'Clauze adăugate',
        deletedClauses: 'Clauze eliminate',
        modifiedClauses: 'Clauze modificate',
        risksIdentified: 'Riscuri identificate',
      },
    },
    headerFooter: {
      button: 'Antet și subsol',
      buttonTooltip: 'Personalizează antetul, subsolul și numerotarea paginilor',
      title: 'Antet și subsol',
      description:
        'Reutilizează antetul sau subsolul dintr-un document Word existent, fără să înlocuiești conținutul documentului curent.',
      pageNumbersBadge: 'Pagini numerotate automat',
      primaryAction: 'Importă antet + subsol',
      primaryActionDesc: 'Alege un document DOCX mai vechi și preia identitatea lui vizuală.',
      importHeader: 'Importă antet din DOCX',
      importHeaderDesc:
        'Preia doar partea de sus a paginii — inclusiv logo, text, tabele și formatare.',
      importFooter: 'Importă subsol din DOCX',
      importFooterDesc: 'Preia doar partea de jos a paginii și păstrează antetul actual.',
      removalSection: 'Eliminare',
      removeHeader: 'Elimină antetul',
      removeHeaderDesc: 'Șterge antetul din documentul curent.',
      removeHeaderDisabledTooltip: 'Documentul nu are antet.',
      removeFooter: 'Elimină subsolul',
      removeFooterDesc:
        'Șterge conținutul subsolului. Numerotarea automată a paginilor rămâne.',
      confirmRemoveHeaderTitle: 'Elimini antetul?',
      confirmRemoveHeaderDesc: 'Conținutul antetului va fi șters din întreg documentul.',
      confirmRemoveHeaderBtn: 'Elimină antetul',
      cancel: 'Anulează',
      loadingImportHeader: 'Se importă antetul din document...',
      loadingImportFooter: 'Se importă subsolul din document...',
      loadingImportBoth: 'Se importă antetul și subsolul...',
      loadingRemove: 'Se actualizează documentul...',
      loadingInspect: 'Se analizează structura documentului sursă...',
      successHeader:
        'Antetul a fost preluat din „{filename}”. Conținutul documentului curent a rămas neschimbat.',
      successFooter:
        'Subsolul a fost preluat din „{filename}”. Conținutul documentului curent a rămas neschimbat.',
      successBoth: 'Antetul și subsolul au fost aplicate documentului curent.',
      successRemoveHeader: 'Antetul a fost eliminat din document.',
      successRemoveFooter:
        'Conținutul subsolului a fost eliminat. Numerotarea automată a rămas activă.',
      undo: 'Anulează',
      undone: 'Modificarea a fost anulată.',
      variantModalTitle: 'Documentul conține mai multe antete/subsoluri',
      variantModalSubtitle: 'Alege varianta pe care vrei să o aplici documentului curent.',
      applyVariantBtn: 'Aplică varianta selectată',
      standardHeader: 'Antet standard',
      firstPageHeader: 'Prima pagină diferită',
      evenPageHeader: 'Pagini pare diferite',
      standardFooter: 'Subsol standard',
      firstPageFooter: 'Subsol prima pagină',
      evenPageFooter: 'Subsol pagini pare',
      sectionPrefix: 'Secțiunea',
      noHeaderInDonor: 'Documentul ales nu conține un antet care poate fi importat.',
      noFooterInDonor: 'Documentul ales nu conține un subsol care poate fi importat.',
      corruptDocx: 'Fișierul Word nu poate fi citit sau este deteriorat.',
      unsupportedElement:
        'Antetul conține un element Word care nu poate fi transferat în siguranță. Documentul curent nu a fost modificat.',
      onlyDocxAllowed:
        'Alege exclusiv un fișier Word (.docx). Formatele PDF sau imagini nu conțin antete Word native.',
    },
    pdfTools: {
      title: 'Instrumente PDF',
      subtitle: 'Procesează documente direct pe infrastructura LegeaAplicată. Fișierele nu sunt trimise către servicii externe.',
      backToList: '← Instrumente PDF',
      compress: 'Comprimă PDF',
      compressDesc: 'Reduce dimensiunea fișierului PDF fără a rasteriza textul sau vectorii.',
      merge: 'Unește PDF-uri',
      mergeDesc: 'Combină mai multe fișiere PDF într-un singur document în ordinea aleasă.',
      split: 'Separă PDF',
      splitDesc: 'Împarte un document PDF la fiecare N pagini sau pe baza unor intervale.',
      extract: 'Extrage pagini',
      extractDesc: 'Selectează una sau mai multe pagini pentru a crea un nou PDF.',
      imagesToPdf: 'Imagini → PDF',
      imagesToPdfDesc: 'Transformă imagini JPG, PNG sau WEBP într-un document PDF format A4.',
      importToEditor: 'PDF / imagine → editor',
      importToEditorDesc: 'Extrage conținutul și deschide documentul în editorul editabil.',
      wordToPdf: 'Word → PDF',
      wordToPdfDesc: 'Convertește documentul curent sau un fișier DOCX încărcat în PDF.',
      uploadPdf: 'Alege fișier PDF',
      addPdfs: '+ Adaugă PDF-uri',
      addImages: '+ Adaugă imagini',
      uploadWord: 'Alege alt document Word',
      convertCurrentDoc: 'Documentul curent',
      exportCurrentPdf: 'Exportă ca PDF',
      exportCurrentPdfHint: 'Deschide caseta nativă de export / tipărire a documentului randat în editor.',
      openOtherWordDesc: 'Vrei să exporți alt document Word? Deschide-l în editor pentru a-l vizualiza, edita și salva direct ca PDF.',
      docOpenedInEditor: 'Documentul a fost încărcat în editor. Poți efectua modificări și exporta ca PDF.',
      orUploadOther: 'sau încarcă alt document Word:',
      compressAndDownload: 'Comprimă și descarcă',
      mergeAndDownload: 'Unește și descarcă',
      splitAndDownload: 'Separă și descarcă',
      extractAndDownload: 'Extrage și descarcă',
      createPdfAndDownload: 'Creează PDF',
      convertAndDownload: 'Convertește în PDF',
      importAndOpen: 'Importă în editor',
      cancel: 'Anulează',
      downloadAgain: 'Descarcă din nou',
      processing: 'Se procesează...',
      profileLabel: 'Profil de comprimare:',
      profileLossless: 'Fără pierdere (Optimizare structurală)',
      profileBalanced: 'Echilibrat (Optimizare imagini standard)',
      profileLow: 'Dimensiune redusă (Comprimare avansată)',
      alreadyOptimized: 'Documentul era deja optimizat și nu s-a obținut o reducere semnificativă.',
      initialSize: 'Dimensiune inițială:',
      finalSize: 'Dimensiune finală:',
      reduction: 'Reducere:',
      splitMode: 'Mod de separare:',
      splitEveryN: 'La fiecare N pagini',
      splitRanges: 'Intervale specifice',
      everyNLabel: 'Separă la fiecare (număr pagini):',
      everyNPlaceholder: 'ex: 5',
      rangesLabel: 'Intervale (ex: 1-3, 4-7, 8-12):',
      rangesPlaceholder: '1-3, 4-7, 8-12',
      extractLabel: 'Pagini de extras (ex: 1, 3, 5-8):',
      extractPlaceholder: '1, 3, 5-8',
      signedPdfWarning: 'Acest PDF conține o semnătură digitală. Orice modificare a documentului poate invalida semnătura.',
      invalidSelection: 'Selectează un fișier valid.',
      minTwoFiles: 'Selectează cel puțin 2 fișiere PDF pentru unire.',
      noFileSelected: 'Niciun fișier selectat.',
      unsupportedWord: 'Alege un fișier .docx valid.',
      failedOperation: 'Operațiunea a eșuat. Te rugăm să încerci din nou.',
      pagesCount: '{count} pagini',
      moveUp: 'Mută mai sus',
      moveDown: 'Mută mai jos',
      remove: 'Elimină',
      successGenerated: 'Documentul a fost generat cu succes.',
      noActiveDocument: 'Nu există un document deschis în editor.',
    },
    services: {
      import: {
        preparingDocx: 'Se pregătește documentul...',
        extractingPdf: 'Se extrage textul din PDF...',
        extractingImage: 'Se procesează imaginea (OCR)...',
        generatingDocx: 'Se construiește documentul Word editabil...',
        emptyFile: 'Fișierul selectat este gol.',
        unsupportedType:
          'Format de fișier neacceptat. Sunt acceptate DOCX, PDF și imagini (JPEG, PNG, TIFF, WebP).',
        fileTooLarge: 'Fișierul depășește limita maximă admisă.',
      },
    },
    mobile: {
      moreOptions: 'Mai multe acțiuni',
      moreOptionsTitle: 'Deschide meniul de acțiuni document',
      undo: 'Anulează',
      redo: 'Refă',
      format: 'Formatare (Aa)',
      insert: 'Inserare (+)',
      assistant: 'Asistent juridic',
      formatSheetTitle: 'Formatare text și paragraf',
      insertSheetTitle: 'Inserează în document',
      assistantSheetTitle: 'Asistent juridic LegeaAplicată',
      documentActionsTitle: 'Acțiuni document',
      style: 'Stil paragraf',
      font: 'Font',
      fontSize: 'Dimensiune font',
      textColor: 'Culoare text',
      highlightColor: 'Evidențiere text',
      alignment: 'Aliniere text',
      lineSpacing: 'Spațiere rânduri',
      listsAndIndent: 'Liste și indentare',
      clearFormatting: 'Elimină formatarea',
      bulletList: 'Listă cu buline',
      numberedList: 'Listă numerotată',
      increaseIndent: 'Mărește indentul',
      decreaseIndent: 'Micșorează indentul',
      alignLeft: 'Stânga',
      alignCenter: 'Centru',
      alignRight: 'Dreapta',
      alignJustify: 'Justificat',
      insertTable: 'Tabel',
      insertImage: 'Imagine',
      insertLink: 'Link',
      insertModel: 'Model juridic',
      insertPageBreak: 'Întrerupere pagină',
      insertSectionBreak: 'Întrerupere secțiune',
      close: 'Închide',
      saved: 'Descărcat',
      unsaved: 'Modificat',
      rows: 'Rânduri',
      cols: 'Coloane',
      insertTableBtn: 'Inserează tabel',
      bold: 'Aldin',
      italic: 'Cursiv',
      underline: 'Subliniat',
      strikethrough: 'Tăiat',
      normalText: 'Text normal',
      titleStyle: 'Titlu',
      subtitleStyle: 'Subtitlu',
      heading1: 'Titlu 1',
      heading2: 'Titlu 2',
      heading3: 'Titlu 3',
      defaultColor: 'Implicit',
      noHighlight: 'Fără evidențiere',
      selectFile: 'Selectează fișier',
      enterUrl: 'Introdu adresa URL',
      linkText: 'Text afișat',
      insertBtn: 'Inserează',
      moreMenuTitle: 'Opțiuni document',
        calculatorsSubtitle: 'Taxe, termene, pedepse și alte calcule',
      compareSubtitle: 'Identificare modificări juridice',
      headerFooterSubtitle: 'Numerotare, antet oficial',
      privacyTitle: 'Sesiune privată (RAM-only)',
      privacyDesc: 'Documentul este păstrat exclusiv în memoria temporară a sesiunii curente și se descarcă manual la cererea dvs.',
      guideSubtitle: 'Ghidul oficial al funcțiilor juridice',
      commandBarLabel: 'Bara de comenzi mobile',
      tabText: 'Text',
      tabParagraph: 'Paragraf',
      styleLabel: 'Stil',
      fontLabel: 'Font',
      sizeLabel: 'Dimensiune',
      alignmentLabel: 'Aliniere',
      listsAndIndents: 'Liste și indentare',
      styleHeading1: 'Titlu 1',
      styleHeading2: 'Titlu 2',
      styleHeading3: 'Titlu 3',
      insertLinkPrompt: 'Introduceți adresa URL:',
      insertTableHint: 'Tabel standard (3x3)',
      insertLegalModel: 'Model juridic',
      insertLegalModelHint: 'Contracte, cereri',
      insertImageHint: 'Galerie sau cameră',
      insertLinkHint: 'Adresă web URL',
      insertLegalScheme: 'Schemă juridică',
      insertLegalSchemeHint: 'Diagrame, fluxuri',
    },
  },

  en: {
    legalPrompt: {
      formattedSuccess: "The document has been drafted and formatted. Use Undo to restore the previous document.",
      attachmentsTitle: "Supporting documents",
      attachFiles: "Attach documents",
      attachmentsHelp: "Optional: up to 10 files, 10 MB each. PDF (up to 200 pages), DOCX, TXT or images; OCR for up to 20 scanned pages per file. Full extracted text is added within the available prompt context. Files are processed temporarily without saving. Review OCR details in the generated document.",
      removeAttachment: "Remove {name}",
      extractingAttachment: "Extracting text: {name}",
      attachmentSelectionError: "Choose up to 10 non-empty files, 10 MB each, in the supported formats.",
      attachmentReadError: "Could not extract the full text from “{name}”. Check or remove the file and retry. The prompt has not been sent to AI.",
      attachmentLimitError: "“{name}” exceeds an extraction limit: 10 MB, 200 PDF pages, 20 OCR pages or 2 million characters. Split it into smaller files and retry.",
      attachmentOcrError: "Scanned text in “{name}” cannot be recognized right now. Retry or use a PDF with selectable text.",
      generateDocumentBtn: 'Generate document in editor',
      writingDocument: 'Your document is being drafted and formatted. This may take a few minutes; your current document remains intact.',
      replaceTitle: 'Replace the document content?',
      replaceWarning: 'Once generation is complete, the current editing content will be deleted and replaced with the requested document. Download the current document first if you want to keep a copy.',
      replaceSafety: 'Replacement occurs only if generation succeeds and the document has not changed. Use Undo in the confirmation banner to restore the previous document.',
      reviewGenerated: 'Data is pseudonymized before AI processing. Names, addresses and other original details are restored automatically in the document. Review the draft and fill in missing information before use.',
      confirmReplace: 'Confirm and generate document',
      cancelReplace: 'Back',
      cancelGeneration: 'Stop generation',
      editorUnavailable: 'The editor is not ready to replace the document.',
      generationFailed: 'The full document could not be generated. Your current document was not changed. You can try again.',
      generationQuota: 'The generation limit was reached or another generation is running. Your document was not changed.',
      promptTooLarge: 'The prompt exceeds the dedicated generation limit. Reduce the context and retry; your document was not changed.',
      title: 'Generate LLM Prompt',
      button: 'Generate LLM Prompt',
      buttonShort: 'Generate prompt',
      subtitle: 'We will automatically attach the full legal context from AI Analysis',
      userRequestLabel: 'What do you want to achieve?',
      userRequestPlaceholder: "e.g., Draft a statement of defense responding specifically to the plaintiff's arguments.",
      autoAddedContext: 'Automatically included context:',
      ctxDoc: 'full pseudonymized document',
      ctxFacts: 'factual situation and extracted facts',
      ctxAnalysis: 'AI analysis and risk checks',
      ctxArticles: 'legal acts and validated citations',
      ctxCase: 'top relevant case law',
      ctxDoctrine: 'doctrine and court stamp duty',
      ctxAnnexes: 'annexes: applicable articles, doctrine, full cases',
      generateBtn: 'Generate prompt',
      generating: 'Preparing prompt context…',
      stepVersion: 'Verifying document revision',
      stepPseudonymize: 'Safely pseudonymizing document',
      stepCase: 'Loading relevant case law and doctrine',
      stepBuild: 'Building Markdown prompt',
      readyTitle: 'Prompt Ready',
      charactersCount: '{count} characters',
      largePromptWarning: 'The prompt is large. Check the context window limit of the model you plan to use.',
      copyBtn: 'Copy prompt',
      downloadBtn: 'Download .md',
      modifyBtn: 'Modify request',
      closeBtn: 'Close',
      copiedToast: 'Prompt copied to clipboard.',
      copyError: 'Could not copy prompt.',
      staleError: 'The document was modified after the last analysis. Run AI Analysis again to generate an updated prompt.',
      staleHint: 'The document has recent changes that have not yet been analyzed by AI.',
      reanalyzeBtn: 'Re-analyze document',
      pseudonymizeError: 'The document could not be safely pseudonymized. Prompt was not generated.',
      noCaseNotice: 'The current analysis did not identify a sufficiently relevant case to include.',
    },
    promptGenerator: {
      title: 'Generate LLM Prompt',
      button: 'Generate LLM Prompt',
      buttonShort: 'Generate prompt',
      subtitle: 'We will automatically attach the full legal context from AI Analysis',
      userRequestLabel: 'What do you want to achieve?',
      userRequestPlaceholder: "e.g., Draft a statement of defense responding specifically to the plaintiff's arguments.",
      autoAddedContext: 'Automatically included context:',
      ctxDoc: 'full pseudonymized document',
      ctxFacts: 'factual situation and extracted facts',
      ctxAnalysis: 'AI analysis and risk checks',
      ctxArticles: 'legal acts and validated citations',
      ctxCase: 'top relevant case law',
      ctxDoctrine: 'doctrine and court stamp duty',
      ctxAnnexes: 'annexes: applicable articles, doctrine, full cases',
      generateBtn: 'Generate prompt',
      generating: 'Preparing prompt context…',
      stepVersion: 'Verifying document version',
      stepPseudonymize: 'Safely pseudonymizing document',
      stepCase: 'Loading relevant case and doctrine',
      stepBuild: 'Building Markdown prompt',
      readyTitle: 'Prompt ready',
      charactersCount: '{count} characters',
      largePromptWarning: 'The prompt is large. Check the context window limit of your target LLM.',
      copyBtn: 'Copy prompt',
      downloadBtn: 'Download .md',
      modifyBtn: 'Modify request',
      closeBtn: 'Close',
      copiedToast: 'Prompt copied to clipboard.',
      copyError: 'Could not copy prompt.',
      staleError: 'The document was modified after the last analysis. Run AI Analysis again to generate an updated prompt.',
      staleHint: 'The document has recent changes that have not yet been analyzed by AI.',
      reanalyzeBtn: 'Re-analyze document',
      pseudonymizeError: 'The document could not be safely pseudonymized. Prompt was not generated.',
      noCaseNotice: 'The current analysis did not identify a sufficiently relevant case to include.',
    },
    calculators: {
      menuLabel: 'Calculators',
      taxaTimbru: 'Court fee',
      termeneJudiciare: 'Procedural deadlines',
      contopiri: 'Sentence merger',
      pensieAlimentara: 'Child maintenance',
      termeneLegale: 'Legal deadlines',
      limite: 'Penalty limits',
      prescriptie: 'Criminal prescription',
      reabilitare: 'Rehabilitation',
      salariu: 'Net / Gross salary',
    },
    schemesModal: {
      modalTitle: 'Insert Legal Diagram',
      modalSubtitle: 'Diagrams, classifications, and decision workflows for your document',
      searchPlaceholder: 'Search diagrams (e.g. nullity, limitation, enforcement, appeal)…',
      allSubjects: 'All subjects',
      allTopics: 'All topics',
      filterByTopic: 'Filter by topic',
      noSchemesFound: 'No diagrams found',
      noSchemesFoundDesc: 'Try other search keywords or choose another subject/topic.',
      selectSchemePrompt: 'Select a diagram from the list',
      selectSchemePromptDesc: 'Choose a legal diagram on the left to preview its structure and insert it into the document.',
      insertBtn: 'Insert into document',
      inserting: 'Generating diagram…',
      demoBadge: 'Free / Demo',
      proBadge: 'Pro',
      lockedTitle: 'Content included in Pro subscription',
      lockedDesc: 'You can insert demo diagrams from every topic for free. Upgrade to Pro for complete access to all 598 legal diagrams.',
      lockedAction: 'View Pro subscriptions',
      legalBasis: 'Legal basis',
      backToList: 'Back to list',
      previewTitle: 'Diagram preview',
      successToast: 'The legal diagram was successfully inserted into the document.',
      errorToast: 'Could not insert the diagram into the document. Please try again.',
      close: 'Close',
    },
    insert: {
      legalSchemes: 'Legal diagram…',
    },
    intelligence: {
      "doctrineTab": "Doctrine",
      "stampDutyTab": "Court fee",
      "argumentSource": "Source",
      "argumentHint": "Extracts from matching cases. Insert a suitable passage together with its source.",
      "argumentActionError": "The action failed. Please try again.",
      "resultSections": "Result sections",
      "argumentsLoadError": "Doctrine and court fee extracts could not be loaded.",
      "argumentsRetry": "Retry",
      "casesTab": "Cases",
      "summary": "Summary",
      "analysisTab": "Analysis",
      "generate": "Analyze with AI",
      "reanalyze": "Reanalyze with AI",
      "analyzing": "Analyzing document…",
      "ready": "Result available",
      "privacy": "Text is anonymized before it is sent to AI. Results remain only in session memory.",
      "document_too_short": "AI analysis requires at least {words} words and {characters} non-space characters.",
      "document_too_long_for_single_pass": "The document exceeds the limit for a single complete analysis.",
      "unavailable": "AI analysis is unavailable. Only local observations are shown. No follow-up request was sent.",
      "empty": "Press \"Analyze with AI\" to identify relevant cases, executive summary, and legal analysis.",
      "minContentHint": "Add at least 6 words (minimum 50 characters) to the document to enable AI Analysis.",
      "authPromptTitle": "Authentication Required",
      "authPromptSubtitle": "For advanced document AI analysis",
      "authPromptMessage": "AI analysis is available to registered users. Create a free account or log in to analyze your document.",
      "createFreeAccount": "Create free account",
      "loginRequired": "Log in",
      "shortContextTitle": "Context too short for full Summary & Analysis",
      "shortContextDesc": "The document contains a short or conceptual context, so AI opted to search and filter relevant cases by legal keywords (available in the \"Cases\" tab). Add detailed facts to the document and press \"Reanalyze with AI\" to generate the full summary and legal analysis.",
      "viewFilteredCasesBtn": "View identified relevant cases",
      "stageTitle": "AI Analysis in progress",
      "stageSubtitle": "Results for Cases, Summary, and Analysis will be displayed together as soon as processing completes.",
      "stage1Title": "Evaluating document and searching candidate cases",
      "stage1Desc": "Analyzing pseudonymized text and selecting the optimal engine (legal keywords or factual similarity).",
      "stage2Title": "Generating executive summary and legal analysis",
      "stage2Desc": "Extracting legal structure, parties, timeline, citations, and risk checks.",
      "stage2Skipped": "Automatically skipped (short context — keyword search)",
      "stage3Title": "AI semantic filtering and relevance sorting of cases",
      "stage3Desc": "Excluding irrelevant cases and ordering rulings descending by AI relevance score.",
      "executive": "Executive summary",
      "parties": "Parties and roles",
      "subject_matter": "Subject matter",
      "contract_terms": "Key terms",
      "obligations": "Obligations",
      "claims_or_accusations": "Claims / accusations",
      "defenses": "Defenses",
      "evidence": "Evidence",
      "procedural_history": "Procedural timeline",
      "decisions_and_outcomes": "Decisions and current stage",
      "penalties_and_deductions": "Sentences, aggregation and deductions",
      "open_questions": "Missing or unclear information",
      "facts": "Extracted facts",
      "statistics": "Local statistics: {words} words · {paragraphs} paragraphs",
      "analysis": "AI legal analysis",
      "local": "Local deterministic observations",
      "risk": "Overall risk",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "unknown": "Unknown",
      "recommendation": "Recommendation",
      "sections": {
            "qualification": "Legal qualification",
            "substantive": "Substantive analysis",
            "procedure": "Procedure",
            "evidence": "Evidence issues",
            "risk": "Counterarguments and risks",
            "calculation": "Calculations",
            "other": "Conclusions and other checks"
      },
      "severity": {
            "risk": "Risk",
            "warning": "Warning",
            "info": "Information"
      },
      "citedText": "Cited text in document (click to navigate)",
},
    page: {
      title: 'Online DOCX Editor for Legal Documents | LegeaAplicată',
      description:
        'Edit DOCX legal documents online on desktop or mobile, with formatting, legal citations, anonymisation, templates, document summaries and version comparison.',
    },
    auth: {
      title: 'Authentication required',
      description:
        'To use the Word Document Editor, you must be registered and logged into your LegeaAplicată account.',
      guaranteesTitle: 'Confidentiality guarantees:',
      guarantee1: '100% self-hosted DOCX editing directly in your browser',
      guarantee2: 'Zero-persistence architecture: documents are not saved to disk',
      guarantee3: 'Automated in-memory anonymisation and legal citation verification',
      guarantee4: 'The document automatically vanishes when closing or reloading the page',
      login: 'Log into your account',
      register: 'Create a free account',
      backToPlatform: 'Back to platform',
    },
    start: {
      back: 'Back',
      backTitle: 'Return to previous page',
      title: 'Online DOCX editor for legal documents',
      subtitle:
        'Documents are processed in a private session and are not retained after closing or reloading the page.',
      privacyBadge: 'Private session — zero persistence',
      privacyExplanation:
        'Your document exists exclusively in volatile memory (RAM) during your current visit. Reloading the page (F5) or closing the window permanently deletes the document. Download the DOCX file before leaving the editor to preserve your changes.',
      uploadButton: 'Upload DOCX, PDF, or image',
      uploadHint1:
        'DOCX opens directly. For PDF and images, we extract the text and transform it into an editable document.',
      uploadHint2:
        'PDF & images: max 10 MB · PDF/TIFF: max 3 pages/frames',
      newDocument: 'New document',
      compareVersions: 'Compare versions',
      cancel: 'Changed my mind, back to platform',
      noWordInstalled: 'No Word installed',
      zeroPersistence: 'Zero persistence',
      autoCleanup: 'Auto-cleanup on exit',
      cancelLoading: 'Cancel',
    },
    topBar: {
      exit: 'Exit',
      exitTitle: 'Close document and return to start screen',
      exitAria: 'Return',
      branding: 'DOCX Editor',
      privateSession: 'Private session',
      privateSessionInfo: 'Private session information',
      zeroPersistenceTitle: 'Zero persistence — Volatile memory',
      zeroPersistenceDesc:
        'The document exists only while this page is open. Reloading or closing the page terminates the session permanently. Download the DOCX file to keep your changes.',
      renameTitle: 'Click to rename the DOCX file',
      undownloadedChanges: 'Undownloaded changes',
      undownloadedConversion: 'Undownloaded conversion',
      downloaded: 'Downloaded',
      headerFooter: 'Header & Footer',
      headerFooterTooltip: 'Customize header, footer and page numbering',
      compareVersions: 'Compare versions',
      compareVersionsTooltip: 'Compare two versions of a contract or document',
      compareDocuments: 'Compare documents',
      downloadDocx: 'Download DOCX',
      downloadDocxTooltip: 'Download DOCX document (Ctrl+S) - The only way to preserve it',
      helpGuide: 'LegeaAplicată Guide',
      hideAssistant: 'Hide assistant panel',
      showAssistant: 'Show assistant panel',
    },
    unsaved: {
      replaceTitle: 'Current document is not saved',
      exitTitle: 'Document is not saved',
      replaceSubtitle: 'You have changes that will be lost if you open another document.',
      exitSubtitle: 'You have changes that exist exclusively in the current session.',
      replaceWarning:
        'LegeaAplicată does not retain editor documents. If you open another document without downloading the current one, the current document and undownloaded changes will be permanently lost.',
      exitWarning:
        'LegeaAplicată does not retain editor documents. If you leave this page, the document and undownloaded changes will be permanently lost.',
      downloadAndContinue: 'Download current document and continue',
      stayInEditor: 'Stay in editor',
      continueWithoutDownload: 'Continue without downloading',
      leaveWithoutDownload: 'Leave without downloading',
    },
    loading: {
      preparingWorkspace: 'Preparing in-memory workspace...',
      loadingRedline: 'Loading tracked changes document into editor...',
      cancel: 'Cancel',
    },
    errors: {
      downloadError: 'Error downloading document.',
      loadError: 'Error loading document.',
      transferExpired: 'The document transfer expired. Please upload the document again.',
      unsupportedFile: 'Unsupported file format.',
      conversionError: 'Error converting file.',
      conversionTimeout:
        'Conversion took too long. Try a smaller document or one with selectable text.',
      createError: 'Error creating document.',
      anonymizationScanError: 'Error scanning personal data.',
      analysisError: 'Error analyzing document.',
      openRedlineError: 'Could not open redline in editor.',
      downloadRedlineError: 'Error downloading tracked changes document.',
      close: 'Close',
      staleAnalysis:
        'The document was modified after the last analysis. Reanalyze for updated data.',
      staleAnalysisHint: 'The document has recent changes that have not yet been analyzed by AI.',
      reanalyzeNow: 'Reanalyze now',
      fileTooLarge: 'The file exceeds the permitted limit of {maxSize}.',
      emptyFile: 'The selected file is empty.',
    },
    assistant: {
      openPanel: 'Open LegeaAplicată panel',
      closePanel: 'Close panel',
      title: 'Assistant',
      rail: {
        models: 'Templates',
        modelsFull: 'Legal templates',
        similarCases: 'Cases',
        similarCasesFull: 'Similar cases',
        dictionary: 'Dictionary',
        dictionaryFull: 'Legal dictionary',
        citations: 'Citations',
        citationsFull: 'Legislative citations',
        anonymization: 'Anonymisation',
        anonymizationFull: 'Document anonymisation',
        companies: 'PF/PJ',
        companiesFull: 'PF/PJ (Individuals / Legal Entities)',
        pdfTools: 'PDF',
        pdfToolsFull: 'PDF Tools',
        analysis: 'AI Analysis',
        analysisFull: 'AI Analysis (Cases, Summary & Analysis)',
        guide: 'Official Guide',
        ariaLabel: 'Assistant legal tools',
        switchTo: 'Switch to {name}',
      },
      citations: {
        title: 'Citations',
        highlight: 'Highlight citations',
        foundSubtitle: 'Found citations based on document content:',
        legalActsCount: 'Legal acts ({count})',
        empty: 'No legislative citations detected in the document.',
        clearResults: 'Clear results',
        options: 'Citation options',
        openHere: 'Open here',
        openInPlatform: 'Open in LegeaAplicată',
        openFull: 'Open full',
        back: 'Back',
        versionFrom: 'Version as of: {date}',
        officialVerified:
          'Verified in official LegeaAplicată database according to the latest Official Gazette updates.',
        status: {
          found: 'in force',
          repealed: 'repealed',
          review: 'to review',
          unresolved: 'unresolved',
          service_error: 'archive',
        },
      },
      models: {
        title: 'Legal templates',
        count: '{count} templates',
        subtitle: 'Search and insert directly into document.',
        searchPlaceholder: 'Search for a legal template...',
        clearSearch: 'Clear search',
        categories: {
          all: 'All',
          civil: 'Civil',
          penal: 'Criminal',
          labor: 'Labor',
        },
        error: 'Error loading legal templates.',
        retry: 'Retry',
        searching: 'Searching templates...',
        emptyTitle: 'No templates found for your search.',
        emptyHint:
          'Try using broader terms like "contract", "application", "notice", or select another category.',
        preview: 'Preview',
        insert: 'Insert',
        inserting: 'Inserting...',
        loadMore: 'Load more templates',
        loadingMore: 'Loading more...',
        backToResults: 'Back to results',
        loadingText: 'Loading template text...',
        noPreviewContent: 'No content available for preview.',
        insertInDoc: 'Insert into document',
        insertedToast: 'Template inserted into document.',
        insertErrorToast: 'Error inserting template into document.',
        defaultTitle: 'Legal Act Template',
        generalModel: 'General legal template',
      },
      similarCases: {
        title: 'Similar cases',
        count: '{count} rulings',
        subtitle: 'Find rulings with factual backgrounds similar to current document.',
        privacyPill: 'Content is pseudonymised prior to AI analysis.',
        searchButton: 'Search similar cases',
        updateButton: 'Update results',
        preparingFacts: 'Preparing factual summary...',
        searchingJurisprudence: 'Searching jurisprudence...',
        formattingResults: 'Formatting results...',
        preparingFactsDesc: 'Analyzing pseudonymised text for factual similarity.',
        searchingJurisprudenceDesc:
          'Comparing facts against national database of court decisions.',
        formattingResultsDesc: 'Structuring excerpts and secure links.',
        factualSemanticMode: 'Search by factual background',
        keywordsMode: 'Search by relevant keywords',
        usedCriteria: 'Criteria used',
        caseObjectHeader: 'Identified case subject:',
        factualSummaryHeader:
          'Factual summary used to identify cases:',
        noFactualSummary: 'No factual summary specified.',
        keywordGroupsHeader: 'Legal keyword groups (Solr):',
        keywordsHeader: 'Legal terms used in search:',
        rerankingInProgress: 'Filtering cases using document summary...',
        rerankingInProgressDesc:
          'Comparing the document summary against the factual background of each candidate case.',
        rerankedBadge: 'Semantically filtered with Summary & Analysis',
        rerankedCount: '{kept} relevant out of {total} candidates',
        rawCandidatesHint:
          'Initial candidate results. Run "Summary & Analysis" for automatic semantic filtering.',
        rerankedEmptyTitle:
          'No candidate case met the semantic relevance threshold.',
        rerankedEmptyDesc:
          'We evaluated {total} candidate cases against the document summary, but their facts concern different legal contexts. You can load more candidates or view raw candidates.',
        rerankFailedError:
          'AI semantic filtering of candidate cases could not be completed. Please try again.',
        showRawCandidates: 'Show raw candidates ({count})',
        showFilteredCandidates: 'Show only relevant cases ({count})',
        rerankReasons: {
          same_legal_object_and_facts: 'Similar legal object and facts',
          similar_factual_pattern: 'Comparable factual pattern',
          same_remedy_and_context: 'Same remedy and legal context',
          different_legal_institution: 'Different legal institution',
          different_factual_context: 'Different factual context',
          insufficient_case_facts: 'Insufficient case facts',
        },
        staleWarning: 'Document was modified after this search.',
        updateNow: 'Update',
        retry: 'Retry',
        insufficientContentTitle:
          'Document does not yet contain enough information to identify relevant cases.',
        insufficientContentDesc:
          'Add the factual background or essential legal elements to the document and try again.',
        smartSearchTitle: 'Intelligent case search',
        smartSearchDesc:
          'Click the button above to analyze your document and find judicial rulings with similar facts.',
        emptyTitle: 'No relevant cases found for the current document content.',
        emptyDesc:
          'You can elaborate on the factual background or reword the document and try again.',
        resumeSearch: 'Restart search',
        loadMore: 'Load more cases',
        loadingMore: 'Loading more...',
        veryHigh: 'Very high relevance',
        high: 'High relevance',
        medium: 'Medium relevance',
        orientative: 'Orientative relevance',
        keywordMatch: 'Keyword match',
        censoredNotice: 'Content partially protected under SCM Decision 998/2022',
        viewDetails: 'View details',
        courtFallback: 'Court',
        upsellTitle: 'Unlock all relevant cases',
        upsellMessage: '{relevantCount} relevant cases were identified. Displaying the top {displayedCount} according to your Basic plan. Upgrade to PRO to see up to 50 relevant cases per document.',
        upsellCta: 'Upgrade to Pro',
        allRelevantShown: 'Displaying all {count} relevant cases identified.',
        proRerankSummary: 'Displaying {displayed} relevant cases sorted by AI relevance (analyzed from {candidates} candidates).',
        caseFallback: 'Court ruling',
        backToCases: 'Back to cases',
        csmNoticeTitle: 'Content protected under SCM Decision 998/2022',
        csmNoticeDesc:
          'Identifying data has been redacted pursuant to Superior Council of Magistracy rules. Unavailable sections cannot be copied or inserted.',
        loadingDetails: 'Loading case details...',
        noFullText: 'The full text of this ruling is not available for display.',
        copied: 'Text copied to clipboard.',
        copyError: 'Error copying text.',
        inserted: 'Section inserted into document.',
        insertError: 'Error inserting into document.',
        insertHeader: 'Similar case — {court}',
        insertDate: 'Date: {date}',
        insertObject: 'Subject: {obj}',
        copy: 'Copy',
        copiedBtn: 'Copied',
        expandAll: 'Expand all',
        collapseAll: 'Collapse all',
        downloadPdf: 'Download PDF',
        print: 'Print',
        share: 'Share',
        pdfDownloaded: 'PDF downloaded.',
        pdfError: 'Error downloading PDF.',
        printError: 'Error initiating print.',
        sections: {
          facts: 'Factual background',
          courtArguments: 'Court arguments',
          considerations: 'Grounds',
          decision: 'Ruling / Disposition',
          aiSummary: 'AI Summary',
          takeaway: 'Key takeaway from this case',
          legalBasis: 'Applicable legal basis',
          evidence: 'Evidence accepted',
        },
      },
      dictionary: {
        title: 'Legal dictionary',
        subtitle: 'Search legal definitions without leaving your document.',
        searchPlaceholder: 'Search for a legal term...',
        clearSearch: 'Clear search',
        singleResult: '1 result',
        multipleResults: '{count} results',
        searching: 'Searching legal dictionary...',
        errorTitle: 'The legal dictionary is temporarily unavailable.',
        errorDesc: 'Check your internet connection or try again.',
        retry: 'Retry',
        initialTitle: 'LegeaAplicată legal dictionary',
        initialHint:
          'Type a term above or select a word in the document and press',
        emptyTitle: 'This term was not found in the legal dictionary.',
        emptyHint: 'Try a shorter phrasing or an equivalent legal term.',
        backToResults: 'Back to results',
        openInNewTab: 'Open in Dictionary',
        openInNewTabTooltip: 'Open in legal dictionary in a new tab',
        loadingDefinition: 'Loading legal definition...',
        loadError: 'Error loading',
        shortDefinition: 'Brief definition',
        extendedDefinition: 'Extended definition',
        synonyms: 'Synonyms',
        searchSynonym: 'Search "{syn}"',
        associatedTerms: 'Associated terms',
        legalBasisArticles: 'Legal basis / Articles',
        associatedJurisprudence: 'Associated case law',
        practicalExamples: 'Practical examples',
        similarTerms: 'Similar terms',
        copyDefinition: 'Copy definition',
        copied: 'Copied!',
      },
      anonymization: {
        title: 'Document Anonymisation',
        engine: 'LegeaAplicată Engine',
        scanButton: 'Scan personal data',
        scanning: 'Scanning personal data...',
        appliedSuccess: 'Successfully anonymised {count} fields in document.',
        identifiedCounts: 'Identified: {total} ({selected} selected)',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        allCategories: 'All',
        emptyHint:
          'Click the button above to automatically identify Names, Personal IDs, IBANs, ID Cards, addresses, and other sensitive data.',
        viewInDoc: 'View in document',
        applyButton: 'Apply anonymisation ({count})',
        applying: 'Applying anonymisation in document...',
        categories: {
          ALL: 'All',
          PERSON: 'Persons',
          CNP: 'National ID',
          IBAN: 'IBAN',
          CI: 'ID Card',
          ADDRESS: 'Addresses',
          PHONE: 'Phone',
          EMAIL: 'Email',
          COMPANY: 'Companies',
          DATE: 'Dates',
        },
      },
      companies: {
        title: 'PF/PJ (Individuals / Legal Entities)',
        entityCount: '{count} entity',
        entityCountPlural: '{count} entities',
        subtitleAuto: 'Entities identified automatically in document.',
        subtitleOnDemand: 'ECRIS and ONRC checks are performed only upon request.',
        onrc: {
          check: "Companies / ONRC role",
          tooltip: "Check whether this person appears as an administrator, director, representative or in another capacity in companies.",
          checking: "Checking ONRC registers…",
          title: "Company roles (ONRC)",
          singleResult: "1 result",
          results: "{count} results",
          empty: "No company associations were identified for this person.",
          partial: "Available results; the list may be incomplete. Name searches may include namesakes.",
          emptyPartial: "No associations were found in the available results. Completeness is unconfirmed.",
          unknownRole: "Role unconfirmed for the searched name",
          error: "The ONRC check could not be completed.",
          rateLimit: "The search limit has been reached. Please wait before trying again.",
          unavailable: "The verification service is temporarily unavailable. Please try again.",
          retry: "Try again",
          viewAll: "View all {count} loaded results",
          collapse: "Collapse results",
          openFull: "Open full search",
          cui: "CUI",
          registry: "Trade register no.",
        },
        refreshTitle: 'Refresh entities',
        refreshAria: 'Refresh companies and individuals',
        filterAll: 'All {count}',
        filterCompanies: 'Companies {count}',
        filterPersons: 'Individuals {count}',
        identifying: 'Identifying entities...',
        identifyingDesc: 'Scanning document for companies and individuals.',
        empty: 'No company or individual identified in document.',
        emptyDesc: 'Entities are detected automatically upon opening this panel.',
        scanAgain: 'Scan again',
        emptyCompanies: 'No company identified in document.',
        emptyPersons: 'No individual identified in document.',
        switchToAll: 'Switch to "All" filter',
        personFallback: 'Individual',
        occurrenceCount: '{count} occurrence',
        occurrenceCountPlural: '{count} occurrences',
        quoteNav: 'Navigate to this passage in document',
        checkCourtCases: 'Check court cases',
        verifiedInDb: 'Verified in database',
        textMention: 'Text mention',
        balance: 'Balance sheet {year}',
        employees: '{count} employees',
        turnover: 'Turnover',
        netProfit: 'Net profit',
        companyDetails: 'Company details',
        litigation: {
          checking: 'Checking...',
          empty: 'No court cases found in internal database.',
          error: 'Could not verify now. Try again.',
          retry: 'Retry',
          title: 'Court cases',
          singleCase: '1 case identified',
          multipleCases: '{count} cases identified',
          caseClickTooltip: 'Click for full case details',
          pendingStatus: 'Pending',
          unspecifiedCourt: 'Unspecified court',
          collapse: 'Collapse case list',
          viewAll: 'View all cases ({count})',
        },
      },
      analysis: {
        title: 'Legal Analysis',
        deterministicRules: 'Deterministic rules',
        analyzeButton: 'Analyze document',
        analyzing: 'Analyzing document...',
        words: 'Words',
        paragraphs: 'Paragraphs',
        findings: 'Findings',
        reading: 'Reading time',
        readingMinutes: '{count} min',
        filterAll: 'All ({count})',
        filterChecks: 'Checks ({count})',
        filterFacts: 'Dates & Amounts ({count})',
        emptyInitial:
          'Click the analysis button to automatically extract chronology, penalties, deadlines, and key clauses from document.',
        emptyCategory: 'No elements identified in this category.',
        viewInDoc: 'View in document',
        kinds: {
          penalty: 'Penalties',
          termination: 'Termination',
          placeholder: 'To complete',
          jurisdiction: 'Jurisdiction',
          date: 'Date',
          amount: 'Amount',
          case: 'Case file',
        },
      },
    },
    comparison: {
      title: 'Compare contract versions',
      subtitle:
        'Deterministic OOXML and legal semantic comparison between two document versions.',
      initialVersion: 'Initial version (A)',
      revisedVersion: 'Revised version (B)',
      swapVersions: 'Swap versions',
      useActiveDoc: 'Use active document',
      activeDocSelected: 'Current document from editor',
      selectDocx: 'Click to choose DOCX file',
      dropDocx: 'Drop DOCX file here or click to browse',
      fileReady: 'File ready for comparison',
      perspectiveTitle: 'Legal analysis perspective (optional)',
      perspectiveHint:
        'Choose the party you represent to assess whether changes favor or disfavor you.',
      perspectiveNeutral: 'Neutral perspective (equal for both parties)',
      partyClient: 'Client / Buyer / Beneficiary / Tenant',
      partyProvider: 'Provider / Supplier / Seller / Landlord',
      partyEmployer: 'Employer',
      partyEmployee: 'Employee',
      partyCustom: 'Other party (specify name)...',
      customPartyPlaceholder: 'Ex: Alpha Logistics LLC or Name Surname',
      securityGuaranteeTitle: 'Security and confidentiality guarantees:',
      security1:
        'Volatile RAM only — files are never stored on disk',
      security2:
        'Deterministic algorithm computes real OOXML changes at paragraph and clause level',
      security3:
        'AI analysis detects hidden risks, newly introduced obligations, and altered deadlines',
      security4:
        'Generated Track Changes document can be opened directly in Word or editor',
      cancel: 'Cancel',
      startComparison: 'Compare versions',
      comparing: 'Comparing versions...',
      stage1: 'Preparing documents in memory...',
      stage2: 'Analyzing text and structural differences...',
      stage3: 'Evaluating legal impact with AI...',
      stage4: 'Generating tracked changes document (redline)...',
      resultsTitle: 'Document comparison results',
      openInEditor: 'Open in editor',
      downloadRedline: 'Download DOCX with changes',
      newComparison: 'New comparison',
      tabLegal: 'What changed legally',
      tabAllChanges: 'All document changes',
      priorityHigh: 'High priority',
      priorityMedium: 'Medium priority',
      priorityLow: 'Low priority',
      materialChange: 'Material change',
      wordingOnly: 'Wording only',
      beforeQuote: 'Previous (Version A)',
      afterQuote: 'Revised (Version B)',
      explanation: 'Legal explanation',
      recommendation: 'Recommendation',
      viewInDocument: 'View in document',
      noFindings:
        'No significant legal changes identified between the two versions.',
      noChanges: 'No structural differences detected.',
      genericError: 'An error occurred while comparing documents.',
      nativeRedlineBadge: 'Redline generated with native Word Tracked Changes',
      summary: {
        addedClauses: 'Added clauses',
        deletedClauses: 'Deleted clauses',
        modifiedClauses: 'Modified clauses',
        risksIdentified: 'Risks identified',
      },
    },
    headerFooter: {
      button: 'Header & Footer',
      buttonTooltip: 'Customize header, footer and page numbering',
      title: 'Header & Footer',
      description:
        'Reuse the header or footer from an existing Word document without replacing current document contents.',
      pageNumbersBadge: 'Automatically numbered pages',
      primaryAction: 'Import header + footer',
      primaryActionDesc: 'Choose an older DOCX document and adopt its visual identity.',
      importHeader: 'Import header from DOCX',
      importHeaderDesc:
        'Takes only the top of the page — including logo, text, tables and styling.',
      importFooter: 'Import footer from DOCX',
      importFooterDesc: 'Takes only the bottom of the page and preserves the current header.',
      removalSection: 'Removal',
      removeHeader: 'Remove header',
      removeHeaderDesc: 'Deletes the header from the current document.',
      removeHeaderDisabledTooltip: 'Document has no header.',
      removeFooter: 'Remove footer',
      removeFooterDesc:
        'Deletes footer content. Automatic page numbering remains active.',
      confirmRemoveHeaderTitle: 'Remove header?',
      confirmRemoveHeaderDesc: 'Header content will be deleted across the entire document.',
      confirmRemoveHeaderBtn: 'Remove header',
      cancel: 'Cancel',
      loadingImportHeader: 'Importing header from document...',
      loadingImportFooter: 'Importing footer from document...',
      loadingImportBoth: 'Importing header and footer...',
      loadingRemove: 'Updating document...',
      loadingInspect: 'Analyzing donor document structure...',
      successHeader:
        'Header imported from “{filename}”. Current document content remained untouched.',
      successFooter:
        'Footer imported from “{filename}”. Current document content remained untouched.',
      successBoth: 'Header and footer applied to the current document.',
      successRemoveHeader: 'Header was removed from the document.',
      successRemoveFooter:
        'Footer content was removed. Automatic page numbering remains active.',
      undo: 'Undo',
      undone: 'Change was reverted.',
      variantModalTitle: 'Document contains multiple headers/footers',
      variantModalSubtitle: 'Select the variant you want to apply to the current document.',
      applyVariantBtn: 'Apply selected variant',
      standardHeader: 'Standard header',
      firstPageHeader: 'Different first page',
      evenPageHeader: 'Different even pages',
      standardFooter: 'Standard footer',
      firstPageFooter: 'First page footer',
      evenPageFooter: 'Even pages footer',
      sectionPrefix: 'Section',
      noHeaderInDonor: 'Selected document contains no importable header.',
      noFooterInDonor: 'Selected document contains no importable footer.',
      corruptDocx: 'Word file cannot be read or is corrupted.',
      unsupportedElement:
        'Header contains a Word element that cannot be safely transferred. Current document was not modified.',
      onlyDocxAllowed:
        'Select strictly a Word file (.docx). PDF and images do not contain native Word headers.',
    },
    pdfTools: {
      title: 'PDF Tools',
      subtitle: 'Process documents directly on LegeaAplicată infrastructure. Files are never sent to external services.',
      backToList: '← PDF Tools',
      compress: 'Compress PDF',
      compressDesc: 'Reduce PDF file size without rasterizing text or vector elements.',
      merge: 'Merge PDFs',
      mergeDesc: 'Combine multiple PDF files into a single document in your chosen order.',
      split: 'Split PDF',
      splitDesc: 'Split a PDF document every N pages or by custom page ranges.',
      extract: 'Extract Pages',
      extractDesc: 'Select one or more pages to create a new PDF.',
      imagesToPdf: 'Images → PDF',
      imagesToPdfDesc: 'Convert JPG, PNG, or WEBP images into an A4 PDF document.',
      importToEditor: 'PDF / Image → Editor',
      importToEditorDesc: 'Extract content and open document in the editable editor.',
      wordToPdf: 'Word → PDF',
      wordToPdfDesc: 'Convert current document or an uploaded DOCX file to PDF.',
      uploadPdf: 'Choose PDF file',
      addPdfs: '+ Add PDFs',
      addImages: '+ Add Images',
      uploadWord: 'Choose another Word document',
      convertCurrentDoc: 'Current document',
      exportCurrentPdf: 'Export as PDF',
      exportCurrentPdfHint: 'Opens the native print / PDF export dialog for the document rendered in the editor.',
      openOtherWordDesc: 'Want to export another Word file? Open it in the editor to preview, edit, and save directly as PDF.',
      docOpenedInEditor: 'Document loaded into editor. You can review and export to PDF.',
      orUploadOther: 'or upload another Word document:',
      compressAndDownload: 'Compress and Download',
      mergeAndDownload: 'Merge and Download',
      splitAndDownload: 'Split and Download',
      extractAndDownload: 'Extract and Download',
      createPdfAndDownload: 'Create PDF',
      convertAndDownload: 'Convert to PDF',
      importAndOpen: 'Import to Editor',
      cancel: 'Cancel',
      downloadAgain: 'Download again',
      processing: 'Processing...',
      profileLabel: 'Compression profile:',
      profileLossless: 'Lossless (Structural optimization)',
      profileBalanced: 'Balanced (Standard image optimization)',
      profileLow: 'Reduced size (Aggressive compression)',
      alreadyOptimized: 'The document was already optimized; no significant reduction was achieved.',
      initialSize: 'Initial size:',
      finalSize: 'Final size:',
      reduction: 'Reduction:',
      splitMode: 'Split mode:',
      splitEveryN: 'Every N pages',
      splitRanges: 'Specific intervals',
      everyNLabel: 'Split every (number of pages):',
      everyNPlaceholder: 'e.g. 5',
      rangesLabel: 'Intervals (e.g. 1-3, 4-7, 8-12):',
      rangesPlaceholder: '1-3, 4-7, 8-12',
      extractLabel: 'Pages to extract (e.g. 1, 3, 5-8):',
      extractPlaceholder: '1, 3, 5-8',
      signedPdfWarning: 'This PDF contains a digital signature. Any modifications may invalidate the signature.',
      invalidSelection: 'Select a valid file.',
      minTwoFiles: 'Select at least 2 PDF files to merge.',
      noFileSelected: 'No file selected.',
      unsupportedWord: 'Select a valid .docx file.',
      failedOperation: 'Operation failed. Please try again.',
      pagesCount: '{count} pages',
      moveUp: 'Move up',
      moveDown: 'Move down',
      remove: 'Remove',
      successGenerated: 'Document was generated successfully.',
      noActiveDocument: 'No document is open in the editor.',
    },
    services: {
      import: {
        preparingDocx: 'Preparing document...',
        extractingPdf: 'Extracting text from PDF...',
        extractingImage: 'Processing image (OCR)...',
        generatingDocx: 'Building editable Word document...',
        emptyFile: 'The selected file is empty.',
        unsupportedType:
          'Unsupported file format. Supported formats are DOCX, PDF, and images (JPEG, PNG, TIFF, WebP).',
        fileTooLarge: 'File exceeds the maximum permitted limit.',
      },
    },
    mobile: {
      moreOptions: 'More actions',
      moreOptionsTitle: 'Open document actions menu',
      undo: 'Undo',
      redo: 'Redo',
      format: 'Format (Aa)',
      insert: 'Insert (+)',
      assistant: 'Legal assistant',
      formatSheetTitle: 'Text & paragraph formatting',
      insertSheetTitle: 'Insert into document',
      assistantSheetTitle: 'LegeaAplicată Legal Assistant',
      documentActionsTitle: 'Document actions',
      style: 'Paragraph style',
      font: 'Font',
      fontSize: 'Font size',
      textColor: 'Text color',
      highlightColor: 'Highlight color',
      alignment: 'Text alignment',
      lineSpacing: 'Line spacing',
      listsAndIndent: 'Lists & indentation',
      clearFormatting: 'Clear formatting',
      bulletList: 'Bullet list',
      numberedList: 'Numbered list',
      increaseIndent: 'Increase indent',
      decreaseIndent: 'Decrease indent',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      alignJustify: 'Justify',
      insertTable: 'Table',
      insertImage: 'Image',
      insertLink: 'Link',
      insertModel: 'Legal model',
      insertPageBreak: 'Page break',
      insertSectionBreak: 'Section break',
      close: 'Close',
      saved: 'Downloaded',
      unsaved: 'Modified',
      rows: 'Rows',
      cols: 'Columns',
      insertTableBtn: 'Insert table',
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      strikethrough: 'Strikethrough',
      normalText: 'Normal text',
      titleStyle: 'Title',
      subtitleStyle: 'Subtitle',
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      heading3: 'Heading 3',
      defaultColor: 'Default',
      noHighlight: 'No highlight',
      selectFile: 'Select file',
      enterUrl: 'Enter URL address',
      linkText: 'Display text',
      insertBtn: 'Insert',
      moreMenuTitle: 'Document options',
        calculatorsSubtitle: 'Fees, deadlines, penalties and other calculations',
      compareSubtitle: 'Identify legal differences',
      headerFooterSubtitle: 'Numbering, official header',
      privacyTitle: 'Private session (RAM-only)',
      privacyDesc: 'The document is kept exclusively in temporary session memory and downloaded manually on demand.',
      guideSubtitle: 'Official guide to legal features',
      commandBarLabel: 'Mobile formatting toolbar',
      tabText: 'Text',
      tabParagraph: 'Paragraph',
      styleLabel: 'Style',
      fontLabel: 'Font',
      sizeLabel: 'Size',
      alignmentLabel: 'Alignment',
      listsAndIndents: 'Lists & indentation',
      styleHeading1: 'Heading 1',
      styleHeading2: 'Heading 2',
      styleHeading3: 'Heading 3',
      insertLinkPrompt: 'Enter URL address:',
      insertTableHint: 'Standard table (3x3)',
      insertLegalModel: 'Legal model',
      insertLegalModelHint: 'Contracts, petitions',
      insertImageHint: 'Gallery or camera',
      insertLinkHint: 'Web URL address',
      insertLegalScheme: 'Legal diagram',
      insertLegalSchemeHint: 'Diagrams, workflows',
    },
  },

  fr: {
    legalPrompt: {
      formattedSuccess: "L’acte a été rédigé et mis en page. Utilisez Annuler pour rétablir le document précédent.",
      attachmentsTitle: "Pièces justificatives",
      attachFiles: "Joindre des pièces",
      attachmentsHelp: "Facultatif : 10 fichiers maximum, 10 Mo chacun. PDF (200 pages maximum), DOCX, TXT ou images ; OCR pour 20 pages numérisées maximum par fichier. Le texte intégral est ajouté dans la limite du contexte disponible. Traitement temporaire sans enregistrement. Vérifiez les données issues de l’OCR dans l’acte généré.",
      removeAttachment: "Retirer {name}",
      extractingAttachment: "Extraction du texte : {name}",
      attachmentSelectionError: "Choisissez au maximum 10 fichiers non vides de 10 Mo chacun, dans les formats acceptés.",
      attachmentReadError: "Impossible d’extraire le texte intégral de « {name} ». Vérifiez ou retirez ce fichier et réessayez. Le prompt n’a pas été envoyé à l’IA.",
      attachmentLimitError: "« {name} » dépasse une limite : 10 Mo, 200 pages PDF, 20 pages OCR ou 2 millions de caractères. Divisez-le en plusieurs fichiers et réessayez.",
      attachmentOcrError: "Le texte numérisé de « {name} » ne peut pas être reconnu pour le moment. Réessayez ou utilisez un PDF avec du texte sélectionnable.",
      generateDocumentBtn: 'Générer l’acte dans l’éditeur',
      writingDocument: 'Votre acte est en cours de rédaction et de mise en page. Cela peut prendre quelques minutes ; le document actuel reste intact.',
      replaceTitle: 'Remplacer le contenu du document ?',
      replaceWarning: 'Une fois la génération terminée, le contenu actuel sera supprimé et remplacé par l’acte demandé. Téléchargez d’abord le document actuel pour en conserver une copie.',
      replaceSafety: 'Le remplacement intervient uniquement si la génération réussit et si le document n’a pas changé. Vous pouvez rétablir le document précédent avec Annuler dans le message de confirmation.',
      reviewGenerated: 'Les données sont pseudonymisées avant le traitement par IA. Les noms, adresses et autres données originales sont restaurés automatiquement dans l’acte. Vérifiez-le et complétez les informations manquantes avant utilisation.',
      confirmReplace: 'Confirmer et générer l’acte',
      cancelReplace: 'Retour',
      cancelGeneration: 'Arrêter la génération',
      editorUnavailable: 'L’éditeur n’est pas prêt à remplacer le document.',
      generationFailed: 'L’acte complet n’a pas pu être généré. Le document actuel n’a pas été modifié. Vous pouvez réessayer.',
      generationQuota: 'La limite de génération est atteinte ou une génération est en cours. Le document n’a pas été modifié.',
      promptTooLarge: 'Le prompt dépasse la limite dédiée. Réduisez le contexte et réessayez ; le document n’a pas été modifié.',
      title: 'Générer le prompt pour LLM',
      button: 'Générer le prompt pour LLM',
      buttonShort: 'Générer le prompt',
      subtitle: "Nous ajouterons automatiquement tout le contexte juridique issu de l'Analyse IA",
      userRequestLabel: 'Que souhaitez-vous obtenir ?',
      userRequestPlaceholder: 'Ex. : Rédige des conclusions en réponse et réponds point par point aux arguments de la partie adverse.',
      autoAddedContext: 'Contexte inclus automatiquement :',
      ctxDoc: 'document intégral pseudonymisé',
      ctxFacts: 'situation de fait et faits extraits',
      ctxAnalysis: 'analyse IA et vérifications de risques',
      ctxArticles: 'textes normatifs et citations validées',
      ctxCase: 'première jurisprudence pertinente',
      ctxDoctrine: 'doctrine et taxe judiciaire',
      ctxAnnexes: 'annexes : articles applicables, doctrine, jurisprudence intégrale',
      generateBtn: 'Générer le prompt',
      generating: 'Préparation du contexte du prompt…',
      stepVersion: 'Vérification de la version du document',
      stepPseudonymize: 'Pseudonymisation sécurisée du document',
      stepCase: 'Chargement de la jurisprudence et doctrine pertinentes',
      stepBuild: 'Construction du prompt Markdown',
      readyTitle: 'Prompt préparé',
      charactersCount: '{count} caractères',
      largePromptWarning: 'Le prompt est volumineux. Vérifiez la limite de contexte du modèle que vous allez utiliser.',
      copyBtn: 'Copier le prompt',
      downloadBtn: 'Télécharger .md',
      modifyBtn: 'Modifier la demande',
      closeBtn: 'Fermer',
      copiedToast: 'Prompt copié dans le presse-papiers.',
      copyError: 'Impossible de copier le prompt.',
      staleError: "Le document a été modifié après la dernière analyse. Relancez l'Analyse IA pour générer un prompt actualisé.",
      staleHint: "Le document contient des modifications récentes qui n'ont pas encore été analysées par l'IA.",
      reanalyzeBtn: 'Réanalyser le document',
      pseudonymizeError: "Le document n'a pas pu être pseudonymisé en toute sécurité. Le prompt n'a pas été généré.",
      noCaseNotice: "L'analyse actuelle n'a pas identifié de jurisprudence suffisamment pertinente.",
    },
    promptGenerator: {
      title: 'Générer le prompt pour LLM',
      button: 'Générer le prompt pour LLM',
      buttonShort: 'Générer le prompt',
      subtitle: "Nous ajouterons automatiquement tout le contexte juridique issu de l'Analyse IA",
      userRequestLabel: 'Que souhaitez-vous obtenir ?',
      userRequestPlaceholder: 'Ex. : Rédige des conclusions en réponse et réponds point par point aux arguments de la partie adverse.',
      autoAddedContext: 'Contexte inclus automatiquement :',
      ctxDoc: 'document intégral pseudonymisé',
      ctxFacts: 'situation de fait et faits extraits',
      ctxAnalysis: 'analyse IA et vérifications de risques',
      ctxArticles: 'textes normatifs et citations validées',
      ctxCase: 'première jurisprudence pertinente',
      ctxDoctrine: 'doctrine et taxe judiciaire',
      ctxAnnexes: 'annexes : articles applicables, doctrine, jurisprudence intégrale',
      generateBtn: 'Générer le prompt',
      generating: 'Préparation du contexte du prompt…',
      stepVersion: 'Vérification de la version du document',
      stepPseudonymize: 'Pseudonymisation sécurisée du document',
      stepCase: 'Chargement de la jurisprudence et doctrine pertinentes',
      stepBuild: 'Construction du prompt Markdown',
      readyTitle: 'Prompt préparé',
      charactersCount: '{count} caractères',
      largePromptWarning: 'Le prompt est volumineux. Vérifiez la limite de contexte du modèle que vous allez utiliser.',
      copyBtn: 'Copier le prompt',
      downloadBtn: 'Télécharger .md',
      modifyBtn: 'Modifier la demande',
      closeBtn: 'Fermer',
      copiedToast: 'Prompt copié dans le presse-papiers.',
      copyError: 'Impossible de copier le prompt.',
      staleError: "Le document a été modifié après la dernière analyse. Relancez l'Analyse IA pour générer un prompt actualisé.",
      staleHint: "Le document contient des modifications récentes qui n'ont pas encore été analysées par l'IA.",
      reanalyzeBtn: 'Réanalyser le document',
      pseudonymizeError: "Le document n'a pas pu être pseudonymisé en toute sécurité. Le prompt n'a pas été généré.",
      noCaseNotice: "L'analyse actuelle n'a pas identifié de jurisprudence suffisamment pertinente.",
    },
    calculators: {
      menuLabel: 'Calculateurs',
      taxaTimbru: 'Taxe judiciaire de timbre',
      termeneJudiciare: 'Délais judiciaires',
      contopiri: 'Fusion des peines',
      pensieAlimentara: 'Pension alimentaire',
      termeneLegale: 'Délais légaux',
      limite: 'Limites de peine',
      prescriptie: 'Prescription pénale',
      reabilitare: 'Réhabilitation',
      salariu: 'Salaire net / brut',
    },
    schemesModal: {
      modalTitle: 'Insérer un Schéma Juridique',
      modalSubtitle: 'Diagrammes, classifications et flux décisionnels pour votre document',
      searchPlaceholder: 'Rechercher des schémas (ex. nullité, prescription, exécution, recours)…',
      allSubjects: 'Toutes les matières',
      allTopics: 'Tous les thèmes',
      filterByTopic: 'Filtrer par thème',
      noSchemesFound: 'Aucun schéma trouvé',
      noSchemesFoundDesc: 'Essayez d\'autres mots-clés ou choisissez une autre matière/thème.',
      selectSchemePrompt: 'Sélectionnez un schéma dans la liste',
      selectSchemePromptDesc: 'Choisissez un schéma juridique à gauche pour prévisualiser sa structure et l\'insérer dans le document.',
      insertBtn: 'Insérer dans le document',
      inserting: 'Génération du diagramme…',
      demoBadge: 'Gratuit / Démo',
      proBadge: 'Pro',
      lockedTitle: 'Contenu inclus dans l\'abonnement Pro',
      lockedDesc: 'Vous pouvez insérer gratuitement les schémas de démonstration de chaque thème. Passez à Pro pour un accès complet aux 598 schémas juridiques.',
      lockedAction: 'Voir les abonnements Pro',
      legalBasis: 'Base légale',
      backToList: 'Retour à la liste',
      previewTitle: 'Aperçu du schéma',
      successToast: 'Le schéma juridique a été inséré avec succès dans le document.',
      errorToast: 'Impossible d\'insérer le schéma dans le document. Veuillez réessayer.',
      close: 'Fermer',
    },
    insert: {
      legalSchemes: 'Schéma juridique…',
    },
    intelligence: {
      "doctrineTab": "Doctrine",
      "stampDutyTab": "Droit de timbre",
      "argumentSource": "Source",
      "argumentHint": "Extraits des affaires trouvées. Insérez un passage pertinent avec sa source.",
      "argumentActionError": "Échec de l’opération. Réessayez.",
      "resultSections": "Sections du résultat",
      "argumentsLoadError": "Les extraits de doctrine et de droit de timbre n’ont pas pu être chargés.",
      "argumentsRetry": "Réessayer",
      "casesTab": "Jurisprudence",
      "summary": "Résumé",
      "analysisTab": "Analyse",
      "generate": "Analyser avec l’IA",
      "reanalyze": "Réanalyser avec l’IA",
      "analyzing": "Analyse du document en cours…",
      "ready": "Résultat disponible",
      "privacy": "Le texte est anonymisé avant son envoi à l’IA. Le résultat reste uniquement dans la mémoire de la session.",
      "document_too_short": "L’analyse IA nécessite au moins {words} mots et {characters} caractères hors espaces.",
      "document_too_long_for_single_pass": "Le document dépasse la limite d’une analyse complète en un seul appel.",
      "unavailable": "L’analyse IA est indisponible. Seules les observations locales sont affichées. Aucune demande complémentaire n’a été envoyée.",
      "empty": "Appuyez sur « Analyser avec l’IA » pour identifier la jurisprudence pertinente, le résumé et l’analyse juridique.",
      "minContentHint": "Ajoutez au moins 6 mots (minimum 50 caractères) dans le document pour activer l’Analyse IA.",
      "authPromptTitle": "Authentification requise",
      "authPromptSubtitle": "Pour l’analyse avancée de documents par IA",
      "authPromptMessage": "L’analyse par IA est réservée aux utilisateurs inscrits. Créez un compte gratuit ou connectez-vous pour analyser votre document.",
      "createFreeAccount": "Créer un compte gratuit",
      "loginRequired": "Se connecter",
      "shortContextTitle": "Contexte trop court pour un Résumé et une Analyse complets",
      "shortContextDesc": "Le document contient un contexte court ou conceptuel ; l’IA a donc recherché et filtré la jurisprudence pertinente par mots-clés juridiques (disponible dans l’onglet « Jurisprudence »). Ajoutez l’exposé détaillé des faits et appuyez sur « Réanalyser avec l’IA » pour générer le résumé et l’analyse.",
      "viewFilteredCasesBtn": "Voir la jurisprudence pertinente identifiée",
      "stageTitle": "Analyse IA en cours de traitement",
      "stageSubtitle": "Les résultats pour la Jurisprudence, le Résumé et l’Analyse s’afficheront simultanément dès la fin du traitement.",
      "stage1Title": "Évaluation du document et recherche de jurisprudence candidate",
      "stage1Desc": "Analyse du texte pseudonymisé et sélection du moteur optimal (mots-clés juridiques ou similarité factuelle).",
      "stage2Title": "Génération du résumé exécutif et de l’analyse juridique",
      "stage2Desc": "Extraction de la structure juridique, des parties, de la chronologie, des citations et des risques.",
      "stage2Skipped": "Ignorée automatiquement (contexte court — recherche par mots-clés)",
      "stage3Title": "Filtrage sémantique IA et tri de la jurisprudence par pertinence",
      "stage3Desc": "Exclusion des décisions non pertinentes et tri décroissant selon le score de pertinence IA.",
      "executive": "Synthèse",
      "parties": "Parties et rôles",
      "subject_matter": "Objet",
      "contract_terms": "Conditions essentielles",
      "obligations": "Obligations",
      "claims_or_accusations": "Prétentions / accusations",
      "defenses": "Moyens de défense",
      "evidence": "Preuves",
      "procedural_history": "Chronologie procédurale",
      "decisions_and_outcomes": "Décisions et stade actuel",
      "penalties_and_deductions": "Peines, cumul et déductions",
      "open_questions": "Informations absentes ou ambiguës",
      "facts": "Données extraites",
      "statistics": "Statistiques locales : {words} mots · {paragraphs} paragraphes",
      "analysis": "Analyse juridique IA",
      "local": "Observations déterministes locales",
      "risk": "Risque global",
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé",
      "unknown": "Inconnu",
      "recommendation": "Recommandation",
      "sections": {
            "qualification": "Qualification juridique",
            "substantive": "Analyse de fond",
            "procedure": "Procédure",
            "evidence": "Questions de preuve",
            "risk": "Contre-arguments et risques",
            "calculation": "Calculs",
            "other": "Conclusions et autres vérifications"
      },
      "severity": {
            "risk": "Risque",
            "warning": "Attention",
            "info": "Information"
      },
      "citedText": "Texte cité dans le document (cliquer pour naviguer)",
},
    page: {
      title: 'Éditeur DOCX en ligne pour documents juridiques | LegeaAplicată',
      description:
        'Modifiez des documents juridiques DOCX en ligne sur ordinateur ou mobile, avec mise en forme, citations, anonymisation, modèles, résumés et comparaison de versions.',
    },
    auth: {
      title: 'Authentification requise',
      description:
        'Pour utiliser l\'Éditeur de documents Word, vous devez être inscrit et connecté à votre compte LegeaAplicată.',
      guaranteesTitle: 'Garanties de confidentialité :',
      guarantee1: 'Édition DOCX 100% auto-hébergée, directement dans le navigateur',
      guarantee2: 'Architecture zéro-persistance : les documents ne sont pas enregistrés sur disque',
      guarantee3: 'Anonymisation automatique et vérification des citations juridiques en mémoire',
      guarantee4: 'Le document disparaît automatiquement à la fermeture ou au rechargement de la page',
      login: 'Connectez-vous à votre compte',
      register: 'Créer un compte gratuit',
      backToPlatform: 'Retour à la plateforme',
    },
    start: {
      back: 'Retour',
      backTitle: 'Revenir à la page précédente',
      title: 'Éditeur DOCX en ligne pour documents juridiques',
      subtitle:
        'Les documents sont traités dans une session privée et ne sont pas conservés après la fermeture ou le rechargement de la page.',
      privacyBadge: 'Session privée — zéro persistance',
      privacyExplanation:
        'Votre document existe exclusivement dans la mémoire volatile (RAM) pendant la visite en cours. Recharger la page (F5) ou fermer la fenêtre supprime irrévocablement le document. Téléchargez le fichier DOCX avant de quitter l\'éditeur pour conserver vos modifications.',
      uploadButton: 'Importer DOCX, PDF ou image',
      uploadHint1:
        'Le format DOCX s\'ouvre directement. Pour les PDF et les images, nous extrayons le texte et le transformons en document éditable.',
      uploadHint2:
        'PDF et images : 10 Mo max. · PDF/TIFF : 3 pages/cadres max.',
      newDocument: 'Nouveau document',
      compareVersions: 'Comparer les versions',
      cancel: 'J\'ai changé d\'avis, retour à la plateforme',
      noWordInstalled: 'Sans Word installé',
      zeroPersistence: 'Zéro persistance',
      autoCleanup: 'Nettoyage automatique à la sortie',
      cancelLoading: 'Annuler',
    },
    topBar: {
      exit: 'Quitter',
      exitTitle: 'Fermer le document et revenir à l\'écran d\'accueil',
      exitAria: 'Retour',
      branding: 'Éditeur DOCX',
      privateSession: 'Session privée',
      privateSessionInfo: 'Informations sur la session privée',
      zeroPersistenceTitle: 'Zéro persistance — Mémoire volatile',
      zeroPersistenceDesc:
        'Le document n\'existe que tant que cette page est ouverte. Recharger ou fermer la page met fin définitivement à la session. Téléchargez le fichier DOCX pour conserver vos modifications.',
      renameTitle: 'Cliquez pour renommer le fichier DOCX',
      undownloadedChanges: 'Modifications non téléchargées',
      undownloadedConversion: 'Conversion non téléchargée',
      downloaded: 'Téléchargé',
      headerFooter: 'En-tête et pied de page',
      headerFooterTooltip: 'Personnaliser l\'en-tête, le pied de page et la numérotation des pages',
      compareVersions: 'Comparer les versions',
      compareVersionsTooltip: 'Comparer deux versions d\'un contrat ou d\'un document',
      compareDocuments: 'Comparer les documents',
      downloadDocx: 'Télécharger DOCX',
      downloadDocxTooltip: 'Télécharger le document DOCX (Ctrl+S) - Le seul moyen de le conserver',
      helpGuide: 'Guide LegeaAplicată',
      hideAssistant: 'Masquer le panneau assistant',
      showAssistant: 'Afficher le panneau assistant',
    },
    unsaved: {
      replaceTitle: 'Le document actuel n\'est pas enregistré',
      exitTitle: 'Le document n\'est pas enregistré',
      replaceSubtitle: 'Vous avez des modifications qui seront perdues si vous ouvrez un autre document.',
      exitSubtitle: 'Vous avez des modifications qui existent exclusivement dans la session en cours.',
      replaceWarning:
        'LegeaAplicată ne conserve pas les documents de l\'éditeur. Si vous ouvrez un autre document sans télécharger l\'actuel, le document actuel et les modifications non téléchargées seront définitivement perdus.',
      exitWarning:
        'LegeaAplicată ne conserve pas les documents de l\'éditeur. Si vous quittez cette page, le document et les modifications non téléchargées seront définitivement perdus.',
      downloadAndContinue: 'Télécharger le document actuel et continuer',
      stayInEditor: 'Rester dans l\'éditeur',
      continueWithoutDownload: 'Continuer sans télécharger',
      leaveWithoutDownload: 'Quitter sans télécharger',
    },
    loading: {
      preparingWorkspace: 'Préparation de l\'espace de travail en mémoire...',
      loadingRedline: 'Chargement du document avec modifications dans l\'éditeur...',
      cancel: 'Annuler',
    },
    errors: {
      downloadError: 'Erreur lors du téléchargement du document.',
      loadError: 'Erreur lors du chargement du document.',
      transferExpired: 'Le transfert du document a expiré. Veuillez importer à nouveau le document.',
      unsupportedFile: 'Format de fichier non pris en charge.',
      conversionError: 'Erreur lors de la conversion du fichier.',
      conversionTimeout:
        'La conversion a pris trop de temps. Essayez un document plus petit ou contenant du texte sélectionnable.',
      createError: 'Erreur lors de la création du document.',
      anonymizationScanError: 'Erreur lors de l\'analyse des données personnelles.',
      analysisError: 'Erreur lors de l\'analyse du document.',
      openRedlineError: 'Impossible d\'ouvrir les modifications dans l\'éditeur.',
      downloadRedlineError: 'Erreur lors du téléchargement du document avec modifications.',
      close: 'Fermer',
      staleAnalysis:
        'Le document a été modifié après la dernière analyse. Réanalysez pour obtenir des données à jour.',
      staleAnalysisHint: "Le document contient des modifications récentes qui n'ont pas encore été analysées par l'IA.",
      reanalyzeNow: 'Réanalyser maintenant',
      fileTooLarge: 'Le fichier dépasse la limite autorisée de {maxSize}.',
      emptyFile: 'Le fichier sélectionné est vide.',
    },
    assistant: {
      openPanel: 'Ouvrir le panneau LegeaAplicată',
      closePanel: 'Fermer le panneau',
      title: 'Assistant',
      rail: {
        models: 'Modèles',
        modelsFull: 'Modèles juridiques',
        similarCases: 'Jurisprudence',
        similarCasesFull: 'Jurisprudence similaire',
        dictionary: 'Dictionnaire',
        dictionaryFull: 'Dictionnaire juridique',
        citations: 'Citations',
        citationsFull: 'Citations législatives',
        anonymization: 'Anonymisation',
        anonymizationFull: 'Anonymisation de document',
        companies: 'PF/PJ',
        companiesFull: 'PF/PJ (Personnes physiques / morales)',
        pdfTools: 'PDF',
        pdfToolsFull: 'Outils PDF',
        analysis: 'Analyse IA',
        analysisFull: 'Analyse IA (Jurisprudence, Résumé et Analyse)',
        guide: 'Guide officiel',
        ariaLabel: 'Outils juridiques de l\'assistant',
        switchTo: 'Basculer vers {name}',
      },
      citations: {
        title: 'Citations',
        highlight: 'Surligner les citations',
        foundSubtitle: 'Citations trouvées selon le contenu du document :',
        legalActsCount: 'Actes juridiques ({count})',
        empty: 'Aucune citation législative détectée dans le document.',
        clearResults: 'Effacer les résultats',
        options: 'Options de citation',
        openHere: 'Ouvrir ici',
        openInPlatform: 'Ouvrir dans LegeaAplicată',
        openFull: 'Ouvrir en plein',
        back: 'Retour',
        versionFrom: 'Version du : {date}',
        officialVerified:
          'Vérifié dans la base officielle LegeaAplicată selon les dernières publications du Journal Officiel.',
        status: {
          found: 'en vigueur',
          repealed: 'abrogé',
          review: 'à vérifier',
          unresolved: 'non identifié',
          service_error: 'archive',
        },
      },
      models: {
        title: 'Modèles juridiques',
        count: '{count} modèles',
        subtitle: 'Recherchez et insérez directement dans le document.',
        searchPlaceholder: 'Rechercher un modèle juridique...',
        clearSearch: 'Effacer la recherche',
        categories: {
          all: 'Toutes',
          civil: 'Civil',
          penal: 'Pénal',
          labor: 'Travail',
        },
        error: 'Erreur lors du chargement des modèles juridiques.',
        retry: 'Réessayer',
        searching: 'Recherche de modèles en cours...',
        emptyTitle: 'Aucun modèle trouvé pour votre recherche.',
        emptyHint:
          'Essayez des termes plus généraux tels que « contrat », « demande », « notification » ou choisissez une autre catégorie.',
        preview: 'Prévisualiser',
        insert: 'Insérer',
        inserting: 'Insertion...',
        loadMore: 'Charger plus de modèles',
        loadingMore: 'Chargement en cours...',
        backToResults: 'Retour aux résultats',
        loadingText: 'Chargement du texte du modèle...',
        noPreviewContent: 'Aucun contenu disponible pour la prévisualisation.',
        insertInDoc: 'Insérer dans le document',
        insertedToast: 'Modèle inséré dans le document.',
        insertErrorToast: 'Erreur lors de l\'insertion du modèle dans le document.',
        defaultTitle: 'Modèle d\'Acte Juridique',
        generalModel: 'Modèle juridique général',
      },
      similarCases: {
        title: 'Jurisprudence similaire',
        count: '{count} décisions',
        subtitle: 'Trouvez des décisions dont les faits sont proches du document actuel.',
        privacyPill: 'Le contenu est pseudonymisé avant l\'analyse IA.',
        searchButton: 'Rechercher de la jurisprudence',
        updateButton: 'Mettre à jour les résultats',
        preparingFacts: 'Préparation de l\'exposé des faits...',
        searchingJurisprudence: 'Recherche dans la jurisprudence...',
        formattingResults: 'Préparation des résultats...',
        preparingFactsDesc: 'Analyse du texte pseudonymisé pour similarité factuelle.',
        searchingJurisprudenceDesc:
          'Comparaison des faits avec la base nationale de jurisprudence.',
        formattingResultsDesc: 'Organisation des extraits et des liens sécurisés.',
        factualSemanticMode: 'Recherche par exposé des faits',
        keywordsMode: 'Recherche par mots-clés pertinents',
        usedCriteria: 'Critères utilisés',
        caseObjectHeader: 'Objet du litige identifié :',
        factualSummaryHeader:
          'Résumé des faits utilisé pour identifier la jurisprudence :',
        noFactualSummary: 'Aucun résumé des faits spécifié.',
        keywordGroupsHeader: 'Groupes de mots-clés juridiques (Solr) :',
        keywordsHeader: 'Termes juridiques utilisés pour la recherche :',
        rerankingInProgress: 'Filtrage des décisions selon le résumé du document...',
        rerankingInProgressDesc:
          'Comparaison du résumé du document avec l\'exposé des faits de chaque décision candidate.',
        rerankedBadge: 'Filtrées sémantiquement avec Résumé & Analyse',
        rerankedCount: '{kept} pertinentes sur {total} candidates',
        rawCandidatesHint:
          'Résultats candidats initiaux. Lancez « Résumé & Analyse » pour un filtrage sémantique automatique.',
        rerankedEmptyTitle:
          'Aucune décision candidate n\'a atteint le seuil de pertinence sémantique.',
        rerankedEmptyDesc:
          'Nous avons évalué {total} décisions candidates par rapport au résumé du document, mais leurs faits concernent d\'autres contextes juridiques. Vous pouvez charger plus de candidates ou afficher les candidates brutes.',
        rerankFailedError:
          'Le filtrage sémantique IA des décisions candidates n\'a pas pu être finalisé. Veuillez réessayer.',
        showRawCandidates: 'Afficher les candidates brutes ({count})',
        showFilteredCandidates: 'Afficher uniquement les décisions pertinentes ({count})',
        rerankReasons: {
          same_legal_object_and_facts: 'Objet juridique et faits similaires',
          similar_factual_pattern: 'Schéma factuel comparable',
          same_remedy_and_context: 'Même recours et contexte juridique',
          different_legal_institution: 'Autre institution juridique',
          different_factual_context: 'Autre contexte factuel',
          insufficient_case_facts: 'Données factuelles insuffisantes',
        },
        staleWarning: 'Le document a été modifié après cette recherche.',
        updateNow: 'Mettre à jour',
        retry: 'Réessayer',
        insufficientContentTitle:
          'Le document ne contient pas encore assez d\'informations pour identifier des décisions pertinentes.',
        insufficientContentDesc:
          'Ajoutez l\'exposé des faits ou les éléments juridiques essentiels dans le document et réessayez.',
        smartSearchTitle: 'Recherche intelligente de jurisprudence',
        smartSearchDesc:
          'Cliquez sur le bouton ci-dessus pour analyser le contenu de votre document et trouver des décisions de justice aux faits similaires.',
        emptyTitle: 'Aucune décision pertinente trouvée pour le contenu actuel du document.',
        emptyDesc:
          'Vous pouvez compléter l\'exposé des faits ou reformuler le document et relancer la recherche.',
        resumeSearch: 'Relancer la recherche',
        loadMore: 'Charger plus de décisions',
        loadingMore: 'Chargement en cours...',
        veryHigh: 'Pertinence très élevée',
        high: 'Pertinence élevée',
        medium: 'Pertinence moyenne',
        orientative: 'Pertinence indicative',
        keywordMatch: 'Correspondance par mots-clés',
        censoredNotice: 'Contenu partiellement protégé selon la Décision CSM 998/2022',
        viewDetails: 'Voir les détails',
        courtFallback: 'Juridiction',
        upsellTitle: 'Débloquez toutes les affaires pertinentes',
        upsellMessage: '{relevantCount} affaires pertinentes ont été identifiées. Affichage des {displayedCount} premières selon votre forfait Basic. Passez à PRO pour afficher jusqu’à 50 affaires par document.',
        upsellCta: 'Passer à Pro',
        allRelevantShown: 'Affichage des {count} affaires pertinentes identifiées.',
        proRerankSummary: 'Affichage de {displayed} affaires pertinentes classées par pertinence IA (analysées parmi {candidates} candidates).',
        caseFallback: 'Décision de justice',
        backToCases: 'Retour à la jurisprudence',
        csmNoticeTitle: 'Contenu protégé par la Décision CSM 998/2022',
        csmNoticeDesc:
          'Les données d\'identification ont été caviardées conformément aux normes du Conseil Supérieur de la Magistrature. Les sections indisponibles ne peuvent être ni copiées ni insérées.',
        loadingDetails: 'Chargement des détails de la décision...',
        noFullText: 'Le texte intégral de cette décision n\'est pas disponible pour affichage.',
        copied: 'Texte copié dans le presse-papiers.',
        copyError: 'Erreur lors de la copie du texte.',
        inserted: 'Section insérée dans le document.',
        insertError: 'Erreur lors de l\'insertion dans le document.',
        insertHeader: 'Jurisprudence similaire — {court}',
        insertDate: 'Date : {date}',
        insertObject: 'Objet : {obj}',
        copy: 'Copier',
        copiedBtn: 'Copié',
        expandAll: 'Tout déplier',
        collapseAll: 'Tout replier',
        downloadPdf: 'Télécharger le PDF',
        print: 'Imprimer',
        share: 'Partager',
        pdfDownloaded: 'PDF téléchargé.',
        pdfError: 'Erreur lors du téléchargement du PDF.',
        printError: 'Erreur lors de l\'impression.',
        sections: {
          facts: 'Exposé des faits',
          courtArguments: 'Arguments de la juridiction',
          considerations: 'Motifs',
          decision: 'Dispositif / Décision',
          aiSummary: 'Résumé IA',
          takeaway: 'Enseignements de cette décision',
          legalBasis: 'Fondement juridique applicable',
          evidence: 'Preuves retenues',
        },
      },
      dictionary: {
        title: 'Dictionnaire juridique',
        subtitle: 'Consultez les définitions juridiques sans quitter le document.',
        searchPlaceholder: 'Rechercher un terme juridique...',
        clearSearch: 'Effacer la recherche',
        singleResult: '1 résultat',
        multipleResults: '{count} résultats',
        searching: 'Recherche dans le dictionnaire juridique...',
        errorTitle: 'Le dictionnaire juridique est temporairement indisponible.',
        errorDesc: 'Vérifiez votre connexion internet ou réessayez l\'opération.',
        retry: 'Réessayer',
        initialTitle: 'Dictionnaire juridique LegeaAplicată',
        initialHint:
          'Tapez un terme ci-dessus ou sélectionnez un mot dans le document et appuyez sur',
        emptyTitle: 'Ce terme n\'a pas été trouvé dans le dictionnaire juridique.',
        emptyHint: 'Essayez une formulation plus courte ou un terme juridique équivalent.',
        backToResults: 'Retour aux résultats',
        openInNewTab: 'Ouvrir dans le Dictionnaire',
        openInNewTabTooltip: 'Ouvrir dans le dictionnaire juridique dans un nouvel onglet',
        loadingDefinition: 'Chargement de la définition juridique...',
        loadError: 'Erreur lors du chargement',
        shortDefinition: 'Définition concise',
        extendedDefinition: 'Définition étendue',
        synonyms: 'Synonymes',
        searchSynonym: 'Rechercher « {syn} »',
        associatedTerms: 'Termes associés',
        legalBasisArticles: 'Fondement juridique / Articles',
        associatedJurisprudence: 'Jurisprudence associée',
        practicalExamples: 'Exemples pratiques',
        similarTerms: 'Termes similaires',
        copyDefinition: 'Copier la définition',
        copied: 'Copié !',
      },
      anonymization: {
        title: 'Anonymisation de document',
        engine: 'Moteur LegeaAplicată',
        scanButton: 'Analyser les données personnelles',
        scanning: 'Analyse des données personnelles...',
        appliedSuccess: '{count} champs ont été anonymisés avec succès dans le document.',
        identifiedCounts: 'Identifiées : {total} ({selected} sélectionnées)',
        selectAll: 'Tout sélectionner',
        deselectAll: 'Tout désélectionner',
        allCategories: 'Toutes',
        emptyHint:
          'Cliquez sur le bouton ci-dessus pour identifier automatiquement les noms, CNP, IBAN, pièces d\'identité, adresses et autres données confidentielles.',
        viewInDoc: 'Voir dans le document',
        applyButton: 'Appliquer l\'anonymisation ({count})',
        applying: 'Application de l\'anonymisation dans le document...',
        categories: {
          ALL: 'Toutes',
          PERSON: 'Personnes',
          CNP: 'Numéro national',
          IBAN: 'IBAN',
          CI: 'Pièce d\'identité',
          ADDRESS: 'Adresses',
          PHONE: 'Téléphone',
          EMAIL: 'Email',
          COMPANY: 'Sociétés',
          DATE: 'Dates',
        },
      },
      companies: {
        title: 'PF/PJ (Personnes physiques / morales)',
        entityCount: '{count} entité',
        entityCountPlural: '{count} entités',
        subtitleAuto: 'Entités identifiées automatiquement dans le document.',
        subtitleOnDemand: 'Les vérifications ECRIS et ONRC sont effectuées uniquement à la demande.',
        onrc: {
          check: "Sociétés / rôle ONRC",
          tooltip: "Vérifiez si cette personne figure comme administrateur, directeur, représentant ou à un autre titre dans des sociétés.",
          checking: "Vérification des registres ONRC…",
          title: "Rôles en société (ONRC)",
          singleResult: "1 résultat",
          results: "{count} résultats",
          empty: "Aucune association avec une société n’a été identifiée pour cette personne.",
          partial: "Résultats disponibles ; la liste peut être incomplète. La recherche par nom peut inclure des homonymes.",
          emptyPartial: "Aucune association trouvée parmi les résultats disponibles. Leur exhaustivité n’est pas confirmée.",
          unknownRole: "Qualité non confirmée pour le nom recherché",
          error: "La vérification ONRC n’a pas pu être effectuée.",
          rateLimit: "La limite de recherches est atteinte. Veuillez patienter avant de réessayer.",
          unavailable: "Le service de vérification est temporairement indisponible. Réessayez.",
          retry: "Réessayer",
          viewAll: "Voir les {count} résultats chargés",
          collapse: "Réduire les résultats",
          openFull: "Ouvrir la recherche complète",
          cui: "CUI",
          registry: "N° du registre du commerce",
        },
        refreshTitle: 'Actualiser les entités',
        refreshAria: 'Actualiser les sociétés et personnes physiques',
        filterAll: 'Toutes {count}',
        filterCompanies: 'Sociétés {count}',
        filterPersons: 'Personnes {count}',
        identifying: 'Identification des entités...',
        identifyingDesc: 'Analyse du document pour trouver les sociétés et personnes physiques.',
        empty: 'Aucune société ou personne physique identifiée dans le document.',
        emptyDesc: 'Les entités sont détectées automatiquement à l\'ouverture de ce panneau.',
        scanAgain: 'Analyser à nouveau',
        emptyCompanies: 'Aucune société identifiée dans le document.',
        emptyPersons: 'Aucune personne physique identifiée dans le document.',
        switchToAll: 'Basculer vers le filtre « Toutes »',
        personFallback: 'Personne physique',
        occurrenceCount: '{count} occurrence',
        occurrenceCountPlural: '{count} occurrences',
        quoteNav: 'Aller à ce passage dans le document',
        checkCourtCases: 'Vérifier les contentieux',
        verifiedInDb: 'Vérifiée dans la base',
        textMention: 'Mention textuelle',
        balance: 'Bilan {year}',
        employees: '{count} salariés',
        turnover: 'Chiffre d\'affaires',
        netProfit: 'Bénéfice net',
        companyDetails: 'Détails de la société',
        litigation: {
          checking: 'Vérification en cours...',
          empty: 'Aucun contentieux trouvé dans la base interne.',
          error: 'Impossible de vérifier pour le moment. Réessayez.',
          retry: 'Réessayer',
          title: 'Contentieux judiciaires',
          singleCase: '1 dossier identifié',
          multipleCases: '{count} dossiers identifiés',
          caseClickTooltip: 'Cliquez pour le détail complet du dossier',
          pendingStatus: 'En cours',
          unspecifiedCourt: 'Juridiction non précisée',
          collapse: 'Réduire la liste des dossiers',
          viewAll: 'Voir tous les dossiers ({count})',
        },
      },
      analysis: {
        title: 'Analyse Juridique',
        deterministicRules: 'Règles déterministes',
        analyzeButton: 'Analyser le document',
        analyzing: 'Analyse du document en cours...',
        words: 'Mots',
        paragraphs: 'Paragraphes',
        findings: 'Constatations',
        reading: 'Lecture',
        readingMinutes: '{count} min',
        filterAll: 'Toutes ({count})',
        filterChecks: 'Vérifications ({count})',
        filterFacts: 'Dates et Montants ({count})',
        emptyInitial:
          'Cliquez sur le bouton d\'analyse pour extraire automatiquement la chronologie, les pénalités, les délais et les clauses clés du document.',
        emptyCategory: 'Aucun élément identifié dans cette catégorie.',
        viewInDoc: 'Voir dans le document',
        kinds: {
          penalty: 'Pénalités',
          termination: 'Résiliation',
          placeholder: 'À compléter',
          jurisdiction: 'Compétence',
          date: 'Date',
          amount: 'Montant',
          case: 'Dossier',
        },
      },
    },
    comparison: {
      title: 'Comparer les versions de contrat',
      subtitle:
        'Analyse déterministe OOXML et sémantique juridique entre deux versions de document.',
      initialVersion: 'Version initiale (A)',
      revisedVersion: 'Version révisée (B)',
      swapVersions: 'Intervertir les versions',
      useActiveDoc: 'Utiliser le document actif',
      activeDocSelected: 'Document actuel de l\'éditeur',
      selectDocx: 'Cliquez pour choisir le fichier DOCX',
      dropDocx: 'Déposez le fichier DOCX ici ou cliquez pour parcourir',
      fileReady: 'Fichier prêt pour la comparaison',
      perspectiveTitle: 'Perspective d\'analyse juridique (facultatif)',
      perspectiveHint:
        'Choisissez la partie que vous représentez pour évaluer si les modifications vous sont favorables ou défavorables.',
      perspectiveNeutral: 'Perspective neutre (équilibrée pour les deux parties)',
      partyClient: 'Client / Acheteur / Bénéficiaire / Locataire',
      partyProvider: 'Prestataire / Fournisseur / Vendeur / Bailleur',
      partyEmployer: 'Employeur',
      partyEmployee: 'Employé',
      partyCustom: 'Autre partie (préciser le nom)...',
      customPartyPlaceholder: 'Ex : Alpha Logistics SARL ou Nom Prénom',
      securityGuaranteeTitle: 'Garanties de sécurité et de confidentialité :',
      security1:
        'Mémoire volatile exclusive (RAM) — les fichiers ne sont pas stockés sur disque',
      security2:
        'L\'algorithme déterministe calcule les modifications OOXML réelles par paragraphe et clause',
      security3:
        'L\'analyse IA détecte les risques dissimulés, les nouvelles obligations et les délais modifiés',
      security4:
        'Le document avec suivi des modifications peut être ouvert directement dans Word ou l\'éditeur',
      cancel: 'Annuler',
      startComparison: 'Comparer les versions',
      comparing: 'Comparaison des versions en cours...',
      stage1: 'Préparation des documents en mémoire...',
      stage2: 'Analyse des différences de texte et de structure...',
      stage3: 'Évaluation de l\'impact juridique avec l\'IA...',
      stage4: 'Génération du document avec suivi des modifications (redline)...',
      resultsTitle: 'Résultats de la comparaison de documents',
      openInEditor: 'Ouvrir dans l\'éditeur',
      downloadRedline: 'Télécharger le DOCX avec modifications',
      newComparison: 'Nouvelle comparaison',
      tabLegal: 'Ce qui a changé juridiquement',
      tabAllChanges: 'Toutes les modifications du document',
      priorityHigh: 'Priorité haute',
      priorityMedium: 'Priorité moyenne',
      priorityLow: 'Priorité basse',
      materialChange: 'Modification substantielle',
      wordingOnly: 'Simple reformulation',
      beforeQuote: 'Précédent (Version A)',
      afterQuote: 'Révisé (Version B)',
      explanation: 'Explication juridique',
      recommendation: 'Recommandation',
      viewInDocument: 'Voir dans le document',
      noFindings:
        'Aucune modification juridique significative identifiée entre les deux versions.',
      noChanges: 'Aucune différence structurelle détectée.',
      genericError: 'Une erreur est survenue lors de la comparaison des documents.',
      nativeRedlineBadge: 'Redline généré avec Word Tracked Changes natif',
      summary: {
        addedClauses: 'Clauses ajoutées',
        deletedClauses: 'Clauses supprimées',
        modifiedClauses: 'Clauses modifiées',
        risksIdentified: 'Risques identifiés',
      },
    },
    headerFooter: {
      button: 'En-tête et pied de page',
      buttonTooltip: 'Personnaliser l\'en-tête, le pied de page et la numérotation des pages',
      title: 'En-tête et pied de page',
      description:
        'Réutilisez l\'en-tête ou le pied de page d\'un document Word existant sans remplacer le contenu du document actuel.',
      pageNumbersBadge: 'Pages numérotées automatiquement',
      primaryAction: 'Importer en-tête + pied de page',
      primaryActionDesc: 'Choisissez un ancien document DOCX et adoptez son identité visuelle.',
      importHeader: 'Importer en-tête depuis DOCX',
      importHeaderDesc:
        'Reprend uniquement le haut de page — y compris logo, texte, tableaux et mise en forme.',
      importFooter: 'Importer pied de page depuis DOCX',
      importFooterDesc: 'Reprend uniquement le bas de page et conserve l\'en-tête actuel.',
      removalSection: 'Suppression',
      removeHeader: 'Supprimer l\'en-tête',
      removeHeaderDesc: 'Supprime l\'en-tête du document actuel.',
      removeHeaderDisabledTooltip: 'Le document n\'a pas d\'en-tête.',
      removeFooter: 'Supprimer le pied de page',
      removeFooterDesc:
        'Supprime le contenu du pied de page. La numérotation automatique des pages reste active.',
      confirmRemoveHeaderTitle: 'Supprimer l\'en-tête ?',
      confirmRemoveHeaderDesc: 'Le contenu de l\'en-tête sera supprimé de tout le document.',
      confirmRemoveHeaderBtn: 'Supprimer l\'en-tête',
      cancel: 'Annuler',
      loadingImportHeader: 'Importation de l\'en-tête en cours...',
      loadingImportFooter: 'Importation du pied de page en cours...',
      loadingImportBoth: 'Importation de l\'en-tête et du pied de page...',
      loadingRemove: 'Mise à jour du document...',
      loadingInspect: 'Analyse de la structure du document source...',
      successHeader:
        'En-tête importé depuis « {filename} ». Le contenu du document actuel est resté intact.',
      successFooter:
        'Pied de page importé depuis « {filename} ». Le contenu du document actuel est resté intact.',
      successBoth: 'En-tête et pied de page appliqués au document actuel.',
      successRemoveHeader: 'L\'en-tête a été supprimé du document.',
      successRemoveFooter:
        'Le contenu du pied de page a été supprimé. La numérotation automatique reste active.',
      undo: 'Annuler',
      undone: 'La modification a été annulée.',
      variantModalTitle: 'Le document contient plusieurs en-têtes/pieds de page',
      variantModalSubtitle: 'Choisissez la variante à appliquer au document actuel.',
      applyVariantBtn: 'Appliquer la variante sélectionnée',
      standardHeader: 'En-tête standard',
      firstPageHeader: 'Première page différente',
      evenPageHeader: 'Pages paires différentes',
      standardFooter: 'Pied de page standard',
      firstPageFooter: 'Pied de première page',
      evenPageFooter: 'Pied de pages paires',
      sectionPrefix: 'Section',
      noHeaderInDonor: 'Le document sélectionné ne contient aucun en-tête importable.',
      noFooterInDonor: 'Le document sélectionné ne contient aucun pied de page importable.',
      corruptDocx: 'Le fichier Word ne peut pas être lu ou est corrompu.',
      unsupportedElement:
        'L\'en-tête contient un élément Word qui ne peut pas être transféré en toute sécurité. Le document actuel n\'a pas été modifié.',
      onlyDocxAllowed:
        'Sélectionnez exclusivement un fichier Word (.docx). Les formats PDF ou image ne contiennent pas d\'en-têtes Word natifs.',
    },
    pdfTools: {
      title: 'Outils PDF',
      subtitle: 'Traitez vos documents directement sur l’infrastructure LegeaAplicată. Les fichiers ne sont jamais envoyés à des services tiers.',
      backToList: '← Outils PDF',
      compress: 'Compresser PDF',
      compressDesc: 'Réduit la taille du fichier PDF sans pixelliser le texte ou les vecteurs.',
      merge: 'Fusionner PDF',
      mergeDesc: 'Combinez plusieurs fichiers PDF en un seul document dans l’ordre choisi.',
      split: 'Diviser PDF',
      splitDesc: 'Divisez un document PDF toutes les N pages ou selon des intervalles spécifiques.',
      extract: 'Extraire des pages',
      extractDesc: 'Sélectionnez une ou plusieurs pages pour créer un nouveau PDF.',
      imagesToPdf: 'Images → PDF',
      imagesToPdfDesc: 'Convertissez des images JPG, PNG ou WEBP en un document PDF A4.',
      importToEditor: 'PDF / Image → Éditeur',
      importToEditorDesc: 'Extrayez le contenu et ouvrez le document dans l’éditeur modifiable.',
      wordToPdf: 'Word → PDF',
      wordToPdfDesc: 'Convertissez le document actuel ou un fichier DOCX importé en PDF.',
      uploadPdf: 'Choisir un fichier PDF',
      addPdfs: '+ Ajouter des PDF',
      addImages: '+ Ajouter des images',
      uploadWord: 'Choisir un autre document Word',
      convertCurrentDoc: 'Document actuel',
      exportCurrentPdf: 'Exporter en PDF',
      exportCurrentPdfHint: "Ouvre la boîte de dialogue native d'export / impression du document affiché dans l'éditeur.",
      openOtherWordDesc: "Vous souhaitez exporter un autre fichier Word ? Ouvrez-le dans l'éditeur pour le prévisualiser, le modifier et l'enregistrer directement en PDF.",
      docOpenedInEditor: "Document chargé dans l'éditeur. Vous pouvez le modifier et l'exporter en PDF.",
      orUploadOther: 'ou charger un autre document Word :',
      compressAndDownload: 'Compresser et télécharger',
      mergeAndDownload: 'Fusionner et télécharger',
      splitAndDownload: 'Diviser et télécharger',
      extractAndDownload: 'Extraire et télécharger',
      createPdfAndDownload: 'Créer le PDF',
      convertAndDownload: 'Convertir en PDF',
      importAndOpen: 'Importer dans l’éditeur',
      cancel: 'Annuler',
      downloadAgain: 'Télécharger à nouveau',
      processing: 'Traitement en cours...',
      profileLabel: 'Profil de compression :',
      profileLossless: 'Sans perte (Optimisation structurelle)',
      profileBalanced: 'Équilibré (Recommandé)',
      profileLow: 'Taille réduite (Compression avancée)',
      alreadyOptimized: 'Le document était déjà optimisé et aucune réduction significative n’a été obtenue.',
      initialSize: 'Taille initiale :',
      finalSize: 'Taille finale :',
      reduction: 'Réduction :',
      splitMode: 'Mode de division :',
      splitEveryN: 'Toutes les N pages',
      splitRanges: 'Intervalles spécifiques',
      everyNLabel: 'Diviser toutes les (nombre de pages) :',
      everyNPlaceholder: 'ex : 5',
      rangesLabel: 'Intervalles (ex : 1-3, 4-7, 8-12) :',
      rangesPlaceholder: '1-3, 4-7, 8-12',
      extractLabel: 'Pages à extraire (ex : 1, 3, 5-8) :',
      extractPlaceholder: '1, 3, 5-8',
      signedPdfWarning: 'Ce PDF contient une signature numérique. Toute modification peut invalider la signature.',
      invalidSelection: 'Sélectionnez un fichier valide.',
      minTwoFiles: 'Sélectionnez au moins 2 fichiers PDF à fusionner.',
      noFileSelected: 'Aucun fichier sélectionné.',
      unsupportedWord: 'Sélectionnez un fichier .docx valide.',
      failedOperation: 'L’opération a échoué. Veuillez réessayer.',
      pagesCount: '{count} pages',
      moveUp: 'Déplacer vers le haut',
      moveDown: 'Déplacer vers le bas',
      remove: 'Supprimer',
      successGenerated: 'Le document a été généré avec succès.',
      noActiveDocument: 'Aucun document ouvert dans l’éditeur.',
    },
    services: {
      import: {
        preparingDocx: 'Préparation du document...',
        extractingPdf: 'Extraction du texte du PDF...',
        extractingImage: 'Traitement de l\'image (OCR)...',
        generatingDocx: 'Création du document Word éditable...',
        emptyFile: 'Le fichier sélectionné est vide.',
        unsupportedType:
          'Format de fichier non pris en charge. Sont acceptés les formats DOCX, PDF et images (JPEG, PNG, TIFF, WebP).',
        fileTooLarge: 'Le fichier dépasse la limite maximale autorisée.',
      },
    },
    mobile: {
      moreOptions: 'Plus d\'actions',
      moreOptionsTitle: 'Ouvrir le menu des actions du document',
      undo: 'Annuler',
      redo: 'Rétablir',
      format: 'Mise en forme (Aa)',
      insert: 'Insérer (+)',
      assistant: 'Assistant juridique',
      formatSheetTitle: 'Mise en forme texte et paragraphe',
      insertSheetTitle: 'Insérer dans le document',
      assistantSheetTitle: 'Assistant juridique LegeaAplicată',
      documentActionsTitle: 'Actions du document',
      style: 'Style de paragraphe',
      font: 'Police',
      fontSize: 'Taille de police',
      textColor: 'Couleur du texte',
      highlightColor: 'Surlignage',
      alignment: 'Alignement du texte',
      lineSpacing: 'Interligne',
      listsAndIndent: 'Listes et retraits',
      clearFormatting: 'Effacer la mise en forme',
      bulletList: 'Liste à puces',
      numberedList: 'Liste numérotée',
      increaseIndent: 'Augmenter le retrait',
      decreaseIndent: 'Diminuer le retrait',
      alignLeft: 'Gauche',
      alignCenter: 'Centré',
      alignRight: 'Droite',
      alignJustify: 'Justifié',
      insertTable: 'Tableau',
      insertImage: 'Image',
      insertLink: 'Lien',
      insertModel: 'Modèle juridique',
      insertPageBreak: 'Saut de page',
      insertSectionBreak: 'Saut de section',
      close: 'Fermer',
      saved: 'Téléchargé',
      unsaved: 'Modifié',
      rows: 'Lignes',
      cols: 'Colonnes',
      insertTableBtn: 'Insérer le tableau',
      bold: 'Gras',
      italic: 'Italique',
      underline: 'Souligné',
      strikethrough: 'Barré',
      normalText: 'Texte normal',
      titleStyle: 'Titre',
      subtitleStyle: 'Sous-titre',
      heading1: 'Titre 1',
      heading2: 'Titre 2',
      heading3: 'Titre 3',
      defaultColor: 'Par défaut',
      noHighlight: 'Sans surlignage',
      selectFile: 'Sélectionner un fichier',
      enterUrl: 'Entrez l\'adresse URL',
      linkText: 'Texte à afficher',
      insertBtn: 'Insérer',
      moreMenuTitle: 'Options du document',
        calculatorsSubtitle: 'Frais, délais, peines et autres calculs',
      compareSubtitle: 'Identifier les modifications juridiques',
      headerFooterSubtitle: 'Numérotation, en-tête officiel',
      privacyTitle: 'Session privée (RAM uniquement)',
      privacyDesc: 'Le document est conservé exclusivement dans la mémoire temporaire de la session et téléchargé manuellement sur demande.',
      guideSubtitle: 'Guide officiel des fonctionnalités juridiques',
      commandBarLabel: 'Barre d\'outils mobile',
      tabText: 'Texte',
      tabParagraph: 'Paragraphe',
      styleLabel: 'Style',
      fontLabel: 'Police',
      sizeLabel: 'Taille',
      alignmentLabel: 'Alignement',
      listsAndIndents: 'Listes et retraits',
      styleHeading1: 'Titre 1',
      styleHeading2: 'Titre 2',
      styleHeading3: 'Titre 3',
      insertLinkPrompt: 'Entrez l\'adresse URL :',
      insertTableHint: 'Tableau standard (3x3)',
      insertLegalModel: 'Modèle juridique',
      insertLegalModelHint: 'Contrats, requêtes',
      insertImageHint: 'Galerie ou appareil photo',
      insertLinkHint: 'Adresse URL web',
      insertLegalScheme: 'Schéma juridique',
      insertLegalSchemeHint: 'Diagrammes, flux',
    },
  },
};
